import { React, useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import useDocumentTitle from './Document'

import './App.css';
import Scroll from './Scroll'
import ScrollToTop from './ScrollToTop';
import CB from './Category/Languages/CB'
import Heading from './Heading/Heading'
import Home from './Centre/Page'
import Footer from './Footer'
import Cards from '../src/Category/Cards'
import Iq from '../src/Category/Languages/Iq'
import Puzz from '../src/Category/Languages/Puzz'
import Flow from './Category/C_Topics/Flow'
import BCC from '../src/Category/C_Topics/BCC'
import Intro from './Category/C_Topics/Intro'
import Psudo from '../src/Category/C_Topics/Psudo'
import Tentime from '../src/Category/C_Topics/tentime'
import Template from '../src/Category/C_Topics/Template'
import Fd from '../src/Category/C_Topics/FandD'
import Data from '../src/Category/C_Topics/Data'
import Scopes from './Category/C_Topics/Scopes'
import Behind from './Category/C_Topics/Behind'
import Keyword from './Category/C_Topics/Keyword'
import Loop from './Category/C_Topics/Loops'
import T_o from './Category/C_Topics/T_o'
import Fourteen from './Category/C_Topics/Fourteen'
import Fifteen from './Category/C_Topics/Fifteen';
import Seventeen from './Category/C_Topics/Seventeen';
import Eighteen from './Category/C_Topics/Eighteen';
import Nineteen from './Category/C_Topics/Nineteen';
import Twenty from './Category/C_Topics/Twenty';
import Twenty_one from './Category/C_Topics/Twenty_one';
import Twenty_two from './Category/C_Topics/Twenty_two';
import Twenty_six from './Category/C_Topics/Twenty_six';
import Twenty_seven from './Category/C_Topics/Twenty_seven';
import Sixty from './Category/C_Topics/Sixty';
import Thirty_five from './Category/C_Topics/Thirty_five';
import Fifty_Nine from './Category/C_Topics/Fifty_Nine';
import Fifty_two from './Category/C_Topics/Fifty_two';
import Fifty_four from './Category/C_Topics/Fifty_four';
import Twenty_five from './Category/C_Topics/Twenty_five';
import Twenty_eight from './Category/C_Topics/Twenty_eight';
import Thirty_two from './Category/C_Topics/Thirty_two';
import Thirty_four from './Category/C_Topics/Thirty_four';
import Thirty_six from './Category/C_Topics/Thirty_six';
import Sixty_two from './Category/C_Topics/Sixty_two';
import Fifty_eight from './Category/C_Topics/Fifty_eight';
import Fifty_one from './Category/C_Topics/Fifty_one';
import Fifty_three from './Category/C_Topics/Fifty_three';
import Fifty_five from './Category/C_Topics/Fifty_five';
import Twenty_three from './Category/C_Topics/Twenty_three';
import Twenty_four from './Category/C_Topics/Twenty_four';
import Linked_list from './Category/C_Topics/Linked_list';
import Stack from './Category/C_Topics/Stack';
import Queue from './Category/C_Topics/Queue'
import Rat_in_Maze from './Category/C_Topics/Rat_in_Maze';
import Sixty_four from './Category/C_Topics/Sixty_four';
import Sixty_three from './Category/C_Topics/Sixty_three';
import DMA from './Category/C_Topics/DMA';
import Fifty_seven from './Category/C_Topics/Fifty_seven';
import Fifty_six from './Category/C_Topics/Fifty_six';
import Array from './Category/C_Topics/Array';
import Thirty from './Category/C_Topics/Thirty';
import Algo from './Category/C_Topics/Algo';
import Binary from './Category/C_Topics/Binary';
import Thirty_seven from './Category/C_Topics/Thirty_seven';
import Thirty_eight from './Category/C_Topics/Thirty_eight';
import Pointer from './Category/C_Topics/Pointer';
import Forty_one from './Category/C_Topics/Forty_one';
import Two_D from './Category/C_Topics/Two_D';
import Rotate from './Category/C_Topics/Rotate';
import String from './Category/C_Topics/String';
import String_rev from './Category/C_Topics/String_rev';



import Python from '../src/Category/Languages/Python'
import Python1 from './Category/Languages/Python1';
import Introduction from './Category/Python_topics/Introduction';
import Input_Output from './Category/Python_topics/Input_Output';
import Varibales from './Category/Python_topics/Varibales';
import Loops from './Category/Python_topics/Loops';
import Alphabet_pattern from './Category/Python_topics/Alphabet_pattern';
import Number_pattern from './Category/Python_topics/Number_pattern';
import Data_types from './Category/Python_topics/Data_types';
import Strings from './Category/Python_topics/Strings'
import Least_string from './Category/Python_topics/Least_string';
import Snake_Pascal from './Category/Python_topics/Snake_Pascal';
import Reverse_string from './Category/Python_topics/Reverse_string';
import Palindrom from './Category/Python_topics/Palindrom';
import Substr from './Category/Python_topics/Subbstr'
import List from './Category/Python_topics/List';
import Reverse_list from './Category/Python_topics/Reverse_list';
import Second_largest from './Category/Python_topics/Second_largest';
import Sort_list from './Category/Python_topics/Sort_list';
import Cloning from './Category/Python_topics/Cloning';
import Tuple from './Category/Python_topics/Tuple'
import Tuple_Cube from './Category/Python_topics/Tuple_Cube';
import Closest_Tuple from './Category/Python_topics/Closest_Tuple';
import Pair_comb from './Category/Python_topics/Pair_comb';
import Nested_tuple from './Category/Python_topics/Nested_tuple';
import Sort_two from './Category/Python_topics/Sort_two';
import Sets from './Category/Python_topics/Sets';
import Dictionary from './Category/Python_topics/Dictionary'
import Unique_dict from './Category/Python_topics/Unique_dict';
import Key_dict from './Category/Python_topics/Key_dict';
import Missing_key from './Category/Python_topics/Missing_key';
import Mirror_char from './Category/Python_topics/Mirror_char';
import Possible_words from './Category/Python_topics/Possible_words';
import Arrays from './Category/Python_topics/Arrays';
import N_queen from './Category/Python_topics/N_queen';
import Rat_maze from './Category/Python_topics/Rat_maze';
import Prime from './Category/Python_topics/Prime';
import Oops from './Category/Python_topics/Oops';
import Class_object from './Category/Python_topics/Class_object';
import Data_object from './Category/Python_topics/Data_object';
import Inheritance from './Category/Python_topics/Inheritance';
import Polymorphism from './Category/Python_topics/Polymorphism';
import Constructors from './Category/Python_topics/Constructors';
import Destructors from './Category/Python_topics/Destructors';
import Metaprogramming from './Category/Python_topics/Metaprogramming';
import Class_attributes from './Category/Python_topics/Class_attributes';
import Exception from './Category/Python_topics/Exception';
import User_define from './Category/Python_topics/User_define';
import Clean from './Category/Python_topics/Clean';
import Try from './Category/Python_topics/Try';
import Deque from './Category/Python_topics/Deque';
import Heap from './Category/Python_topics/Heap';
import Numpy from './Category/Python_topics/Numpy';
import Sorting from './Category/Python_topics/SSS';
import Pandas from './Category/Python_topics/Pandas';
import P_series from './Category/Python_topics/P_series';
import Data_frame from './Category/Python_topics/Data_frame';
import Conversion from './Category/Python_topics/Conversion';
import Machine_learn from './Category/Python_topics/Machine_learn';
import Modules from './Category/Python_topics/Modules';
import Calender from './Category/Python_topics/Calender';
import Os_module from './Category/Python_topics/Os_module';
import Mongo_db from './Category/Python_topics/Mongo_db';
import Impot from './Category/Python_topics/Impot';
import Django from './Category/Python_topics/Django';
import Data_anal from './Category/Python_topics/Data_anal';


import Main from './Category/Languages/Main'
import Introd from './Category/Cpp_topics/Intro';
import Bcc from './Category/Cpp_topics/Bcc';
import Flow_Pseudo from './Category/Cpp_topics/Flow_pse';
import Hello from './Category/Cpp_topics/Hello';
import Primes from './Category/Cpp_topics/Prime'
import Sum_of_n from './Category/Cpp_topics/Sum_of_n';
import Concept from './Category/Cpp_topics/Concepts'
import Temp from './Category/Cpp_topics/Temp';
import Varaible_const from './Category/Cpp_topics/Varaible_const';
import Loopse from './Category/Cpp_topics/Loopse';
import Odd_even from './Category/Cpp_topics/Odd_even';
import Ap from './Category/Cpp_topics/Ap';
import Primed from './Category/Cpp_topics/Primes';
import D_B from './Category/Cpp_topics/D_B';
import Cr from './Category/Cpp_topics/Cr';
import Alp from './Category/Cpp_topics/Alp';
import D_t from './Category/Cpp_topics/D_t';
import Arr from './Category/Cpp_topics/Arr';
import Arr_rev from './Category/Cpp_topics/Arr_rev';
import Cp_linear from './Category/Cpp_topics/Cp_linear';
import Cp_bubble from './Category/Cpp_topics/Cp_bubble';
import Cp_selection from './Category/Cpp_topics/Cp_selection';
import Cp_pointer from './Category/Cpp_topics/Cp_pointer';
import Cp_default from './Category/Cpp_topics/Cp_default';
import Cp_str from './Category/Cpp_topics/Cp_str';
import Cp_rot from './Category/Cpp_topics/Cp_rot';
import CP_strRev from './Category/Cpp_topics/CP_strRev';

import Cp_mStr from './Category/Cpp_topics/Cp_mStr';
import Cpp_dpStr from './Category/Cpp_topics/Cpp_dpStr';
import Cp_perm from './Category/Cpp_topics/Cp_perm';
import Cpp_tog from './Category/Cpp_topics/Cpp_tog';
import Recur from './Category/Cpp_topics/Recur';
import Cp_palin from './Category/Cpp_topics/Cp_palin';
import Cp_DMA from './Category/Cpp_topics/Cp_DMA';
import Cp_rm from './Category/Cpp_topics/Cp_rm';
import Cp_nque from './Category/Cpp_topics/Cp_nque';
import Cp_ops from './Category/Cpp_topics/Cp_ops';
import Cp_clas from './Category/Cpp_topics/Cp_clas';
import C_inh from './Category/Cpp_topics/C_inh';
import Cp_link from './Category/C_Topics/Cp_link';
import Cp_del from './Category/Cpp_topics/Cp_del';
import Cp_whd from './Category/Cpp_topics/Cp_whd';
import Cp_int from './Category/Cpp_topics/Cp_int';
import Cp_mrg from './Category/Cpp_topics/Cp_mrg';
import Cp_stk from './Category/Cpp_topics/Cp_stk';
import Cp_st_rev from './Category/Cpp_topics/Cp_st_rev';
import Cp_set from './Category/Cpp_topics/Cp_set';
import Cp_sto from './Category/Cpp_topics/Cp_sto';
import Cp_celeb from './Category/Cpp_topics/Cp_celeb';
import Cp_Toh from './Category/Cpp_topics/Cp_Toh';
import Cp_st_srt from './Category/Cpp_topics/Cp_st_srt';
import Cp_que from './Category/Cpp_topics/Cp_que';
import Cp_vec from './Category/Cpp_topics/Cp_vec';
import Cp_map from './Category/Cpp_topics/Cp_map';


import Java from './Category/Languages/Java'
import Jva_Intoduction from './Category/Java_topics/Jva_Intoduction';
import Jva_BCC from './Category/Java_topics/Jva_BCC';
import Jva_flow from './Category/Java_topics/Jva_flow';
import Jva_hello from './Category/Java_topics/Jva_hello';
import Jva_Prime from './Category/Java_topics/Jva_Prime';
import Jva_sum from './Category/Java_topics/Jva_sum';
import Jva_Basic from './Category/Java_topics/Jva_Basic';
import Jva_temp from './Category/Java_topics/Jva_temp';
import Jva_io from './Category/Java_topics/Jva_io';
import Jva_Vck from './Category/Java_topics/Jva_Vck';
import Jva_main from './Category/Java_topics/Jva_main';
import Jva_dt from './Category/Java_topics/Jva_dt';
import Jva_loop from './Category/Java_topics/Jva_loop';
import Jva_N from './Category/Java_topics/Jva_N';
import Jva_ap from './Category/Java_topics/Jva_ap';
import Jva_cs from './Category/Java_topics/Jva_cs';
import Jva_checkP from './Category/Java_topics/Jva_checkP';
import Jva_Bd from './Category/Java_topics/Jva_Bd';
import Jva_ncr from './Category/Java_topics/Jva_ncr';
import Jva_Pattern from './Category/Java_topics/Jva_Pattern';
import Jva_arr from './Category/Java_topics/Jva_arr';
import Jva_arrRev from './Category/Java_topics/Jva_arrRev';
import Jva_Ls from './Category/Java_topics/Jva_Ls';
import Jva_mat from './Category/Java_topics/Jva_mat';
import Jva_bs from './Category/Java_topics/Jva_bs';
import Jva_sel from './Category/Java_topics/Jva_sel';
import Jva_ref from './Category/Java_topics/Jva_ref';
import Jva_str from './Category/Java_topics/Jva_str';
import Jva_sss from './Category/Java_topics/Jva_sss';
import Jva_strRev from './Category/Java_topics/Jva_strRev';
import Jva_maxChar from './Category/Java_topics/Jva_maxChar';
import Jva_Dup from './Category/Java_topics/Jva_Dup';
import Jva_tog from './Category/Java_topics/Jva_tog';
import Jva_rec from './Category/Java_topics/Jva_rec';
import Jva_pal from './Category/Java_topics/Jva_pal';
import Jva_perm from './Category/Java_topics/Jva_perm';
import Jva_rmz from './Category/Java_topics/Jva_rmz';
import Jva_nque from './Category/Java_topics/Jva_nque';
import Jva_oops from './Category/Java_topics/Jva_oops';
import Jva_dma from './Category/Java_topics/Jva_dma';
import Jva_poly from './Category/Java_topics/Jva_class';
import Jva_class from './Category/Java_topics/Jva_class';
import Jva_method from './Category/Java_topics/Jva_method';
import Jva_exce from './Category/Java_topics/Jva_exce';
import Jva_abs from './Category/Java_topics/Jva_abs';
import Jva_arrL from './Category/Java_topics/Jva_arrL';
import Jva_ll from './Category/Java_topics/Jva_ll';
import Jva_posD from './Category/Java_topics/Jva_posD';
import Jva_int from './Category/Java_topics/Jva_int';
import Jva_del from './Category/Java_topics/Jva_del';
import Jva_merge from './Category/Java_topics/Jva_merge';
import Jva_stk from './Category/Java_topics/Jva_stk';
import Jva_stkRev from './Category/Java_topics/Jva_stkRev';
import Jva_stIf from './Category/Java_topics/Jva_stIf';
import Jva_stock from './Category/Java_topics/Jva_stock';
import Jva_cleb from './Category/Java_topics/Jva_cleb';
import Jva_toh from './Category/Java_topics/Jva_toh';
import Jva_sort from './Category/Java_topics/Jva_sort';
import Jv_que from './Category/Java_topics/Jv_que';
import Jva_set from './Category/Java_topics/Jva_set';
import Jva_vec from './Category/Java_topics/Jva_vec';
import Jva_map from './Category/Java_topics/Jva_map';



import Puzz1 from './Category/Languages/Puzz1'
import Puz1 from './Category/Quiz_time/Puz1'
import Puz2 from './Category/Quiz_time/Puz2'
import Puzth from './Category/Quiz_time/Puzth';
import Puzfo from './Category/Quiz_time/Puzfo';
import Puzfi from './Category/Quiz_time/Puzfi';
import Puzsi from './Category/Quiz_time/Puzsi';
import Puzse from './Category/Quiz_time/Puzse';
import Puzei from './Category/Quiz_time/Puzei';
import Puzni from './Category/Quiz_time/Puzni';
import Puzte from './Category/Quiz_time/Puzte';
import Puzel from './Category/Quiz_time/Puzel';
import Puz12 from './Category/Quiz_time/Puz12';
import Puz13 from './Category/Quiz_time/Puz13';
import Puz14 from './Category/Quiz_time/Puz14';
import Puz15 from './Category/Quiz_time/Puz15';
import Puz16 from './Category/Quiz_time/Puz16';
import Puz17 from './Category/Quiz_time/Puz17';
import Puz18 from './Category/Quiz_time/Puz18';
import Puz19 from './Category/Quiz_time/Puz19';
import Puz20 from './Category/Quiz_time/Puz20';
import Puz21 from './Category/Quiz_time/Puz21';
import Puz22 from './Category/Quiz_time/Puz22';
import Puz23 from './Category/Quiz_time/Puz23';
import Puz24 from './Category/Quiz_time/Puz24';
import Puz25 from './Category/Quiz_time/Puz25';
import Puz26 from './Category/Quiz_time/Puz26';
import Puz27 from './Category/Quiz_time/Puz27';
import Puz28 from './Category/Quiz_time/Puz28';
import Puz29 from './Category/Quiz_time/Puz29';
import Puz30 from './Category/Quiz_time/Puz30';
import Puz31 from './Category/Quiz_time/Puz31';
import Puz32 from './Category/Quiz_time/Puz32';
import Puz33 from './Category/Quiz_time/Puz33';
import Puz34 from './Category/Quiz_time/Puz34';
import Puz35 from './Category/Quiz_time/Puz35';
import Puz36 from './Category/Quiz_time/Puz36';
import Puz37 from './Category/Quiz_time/Puz37';
import Puz38 from './Category/Quiz_time/Puz38';
import Puz39 from './Category/Quiz_time/Puz39';
import Puz40 from './Category/Quiz_time/Puz40';
import Puz41 from './Category/Quiz_time/Puz41';
import Puz42 from './Category/Quiz_time/Puz42';
import Puz43 from './Category/Quiz_time/Puz43';
import Puz44 from './Category/Quiz_time/Puz44';
import Puz45 from './Category/Quiz_time/Puz45';




import Somes from './Category/IQ/Somes';
import Iq2 from './Category/IQ/Iq2';
import Iq3 from './Category/IQ/Iq3';
import Iq4 from './Category/IQ/Iq4';
import Iq5 from './Category/IQ/Iq5';
import Iq6 from './Category/IQ/Iq6';
import Iq7 from './Category/IQ/Iq7';
import Iq8 from './Category/IQ/Iq8';
import Iq9 from './Category/IQ/Iq9';
import Iq10 from './Category/IQ/Iq10';

import Br1 from './Category/Br/Br1'
import Order from './Category/Rearrange/Order';


import Amazn from './Category/Languages/Amazn';
import Ggle from './Category/Languages/Ggle';
import Mcrsft from './Category/Languages/Mcrsft'

import Snapdeal from './Category/Languages/Snapdeal'
import Qualcomm from './Category/Languages/Qualcomm'
import Samsung from './Category/Languages/Samsung'
import Flpkrt from './Category/Languages/Flpkrt'
import Mmt from './Category/Languages/Mmt'
import Gs from './Category/Languages/Gs'
import Acc from './Category/Languages/Acc'
import Yho from './Category/Languages/Yho'
import Dshaw from './Category/Languages/Dshaw'
import Paytm from './Category/Languages/Paytm'
import Ola from './Category/Languages/Ola'
import Cisco from './Category/Languages/Cisco'

import Amz1 from './Category/Amazon/Amz1';
import Amz2 from './Category/Amazon/Amz2';
import Amz3 from './Category/Amazon/Amz3';
import Amz4 from './Category/Amazon/Amz4';
import Amz20 from './Category/Amazon/Amz20';
import Amz5 from './Category/Amazon/Amz5';
import Amz6 from './Category/Amazon/Amz6';
import Amz7 from './Category/Amazon/Amz7';
import Amz8 from './Category/Amazon/Amz8';
import Amz9 from './Category/Amazon/Amz9';
import Amz10 from './Category/Amazon/Amz10';
import Amz11 from './Category/Amazon/Amz11';
import Amz12 from './Category/Amazon/Amz12';
import Amz13 from './Category/Amazon/Amz13';
import Amz14 from './Category/Amazon/Amz14';
import Amz15 from './Category/Amazon/Amz15';
import Amz16 from './Category/Amazon/Amz16';
import Amz17 from './Category/Amazon/Amz17';
import Amz18 from './Category/Amazon/Amz18';
import Amz19 from './Category/Amazon/Amz19';

import Ggle1 from './Category/Google/Ggle1'
import Ggle2 from './Category/Google/Ggle2'
import Ggle3 from './Category/Google/Ggle3'
import Ggle4 from './Category/Google/Ggle4'
import Ggle5 from './Category/Google/Ggle5'
import Ggle6 from './Category/Google/Ggle6'
import Ggle7 from './Category/Google/Ggle7'
import Ggle8 from './Category/Google/Ggle8'
import Ggle9 from './Category/Google/Ggle9'
import Ggle10 from './Category/Google/Ggle10'
import Ggle11 from './Category/Google/Ggle11'
import Ggle12 from './Category/Google/Ggle12'
import Ggle13 from './Category/Google/Ggle13'
import Ggle14 from './Category/Google/Ggle14'
import Ggle15 from './Category/Google/Ggle15'


import Mcrsft2 from './Category/Microsoft/Mcrsft2';
import Mcrsft3 from './Category/Microsoft/Mcrsft3';
import Mcrsft4 from './Category/Microsoft/Mcrsft4';
import Mcrsft5 from './Category/Microsoft/Mcrsft5';
import Mcrsft6 from './Category/Microsoft/Mcrsft6';
import Mcrsft7 from './Category/Microsoft/Mcrsft7';
import Mcrsft8 from './Category/Microsoft/Mcrsft8';
import Mcrsft9 from './Category/Microsoft/Mcrsft9';
import Mcrsft10 from './Category/Microsoft/Mcrsft10';
import Mcrsft11 from './Category/Microsoft/Mcrsft11';
import Mcrsft12 from './Category/Microsoft/Mcrsft12';
import Mcrsft13 from './Category/Microsoft/Mcrsft13';
import Mcrsft14 from './Category/Microsoft/Mcrsft14';
import Mcrsft15 from './Category/Microsoft/Mcrsft15';
import Mcrsft16 from './Category/Microsoft/Mcrsft16';

import Dsw1 from './Category/Deshaw/Dsw1';
import Dsw2 from './Category/Deshaw/Dsw2';
import Dsw3 from './Category/Deshaw/Dsw3';
import Dsw4 from './Category/Deshaw/Dsw4';
import Dsw5 from './Category/Deshaw/Dsw5';
import Dsw6 from './Category/Deshaw/Dsw6';
import Dsw7 from './Category/Deshaw/Dsw7';
import Dsw8 from './Category/Deshaw/Dsw8';
import Dsw9 from './Category/Deshaw/Dsw9';
import Dsw10 from './Category/Deshaw/Dsw10';
import Dsw11 from './Category/Deshaw/Dsw11';
import Dsw12 from './Category/Deshaw/Dsw12';
import Dsw13 from './Category/Deshaw/Dsw13';
import Dsw14 from './Category/Deshaw/Dsw14';
import Dsw15 from './Category/Deshaw/Dsw15';
import Dsw16 from './Category/Deshaw/Dsw16';

import Acc1 from './Category/Accolite/Acc1'
import Acc2 from './Category/Accolite/Acc2'
import Acc3 from './Category/Accolite/Acc3'
import Acc4 from './Category/Accolite/Acc4'
import Acc5 from './Category/Accolite/Acc5'
import Acc6 from './Category/Accolite/Acc6'
import Acc7 from './Category/Accolite/Acc7'
import Acc8 from './Category/Accolite/Acc8'
import Acc9 from './Category/Accolite/Acc9'
import Acc10 from './Category/Accolite/Acc10'
import Acc11 from './Category/Accolite/Acc11'
import Acc12 from './Category/Accolite/Acc12'
import Acc13 from './Category/Accolite/Acc13'
import Acc14 from './Category/Accolite/Acc14'
import Acc15 from './Category/Accolite/Acc15'

import Yho1 from './Category/Yahoo/Yho1'
import Yho2 from './Category/Yahoo/Yho2'
import Yho3 from './Category/Yahoo/Yho3'
import Yho4 from './Category/Yahoo/Yho4'
import Yho5 from './Category/Yahoo/Yho5'
import Yho6 from './Category/Yahoo/Yho6'
import Yho7 from './Category/Yahoo/Yho7'
import Yho8 from './Category/Yahoo/Yho8'
import Yho9 from './Category/Yahoo/Yho9'
import Yho10 from './Category/Yahoo/Yho10'
import Yho11 from './Category/Yahoo/Yho11'
import Yho12 from './Category/Yahoo/Yho12'
import Yho13 from './Category/Yahoo/Yho13'
import Yho14 from './Category/Yahoo/Yho14'
import Yho15 from './Category/Yahoo/Yho15'

import Gld1 from './Category/Goldman/Gld1'
import Gld2 from './Category/Goldman/Gld2'
import Gld3 from './Category/Goldman/Gld3'
import Gld4 from './Category/Goldman/Gld4'
import Gld5 from './Category/Goldman/Gld5'
import Gld6 from './Category/Goldman/Gld6'
import Gld7 from './Category/Goldman/Gld7'
import Gld8 from './Category/Goldman/Gld8'
import Gld9 from './Category/Goldman/Gld9'
import Gld10 from './Category/Goldman/Gld10'
import Gld11 from './Category/Goldman/Gld11'
import Gld12 from './Category/Goldman/Gld12'
import Gld13 from './Category/Goldman/Gld13'
import Gld14 from './Category/Goldman/Gld14'
import Gld15 from './Category/Goldman/Gld15'

import Mt1 from './Category/Mmt/Mt1'
import Mt2 from './Category/Mmt/Mt2'
import Mt3 from './Category/Mmt/Mt3'
import Mt4 from './Category/Mmt/Mt4'
import Mt5 from './Category/Mmt/Mt5'
import Mt6 from './Category/Mmt/Mt6'
import Mt7 from './Category/Mmt/Mt7'
import Mt8 from './Category/Mmt/Mt8'
import Mt9 from './Category/Mmt/Mt9'
import Mt10 from './Category/Mmt/Mt10'
import Mt11 from './Category/Mmt/Mt11'
import Mt12 from './Category/Mmt/Mt12'
import Mt13 from './Category/Mmt/Mt13'
import Mt14 from './Category/Mmt/Mt14'
import Mt15 from './Category/Mmt/Mt15'

import Flpkrt1 from './Category/Flipkart/Flpkrt1';
import Flpkrt2 from './Category/Flipkart/Flpkrt2';
import Flpkrt3 from './Category/Flipkart/Flpkrt3';
import Flpkrt4 from './Category/Flipkart/Flpkrt4';
import Flpkrt5 from './Category/Flipkart/Flpkrt5';
import Flpkrt6 from './Category/Flipkart/Flpkrt6';
import Flpkrt7 from './Category/Flipkart/Flpkrt7';
import Flpkrt8 from './Category/Flipkart/Flpkrt8';
import Flpkrt9 from './Category/Flipkart/Flpkrt9';
import Flpkrt10 from './Category/Flipkart/Flpkrt10';
import Flpkrt11 from './Category/Flipkart/Flpkrt11';
import Flpkrt12 from './Category/Flipkart/Flpkrt12';
import Flpkrt13 from './Category/Flipkart/Flpkrt13';
import Flpkrt14 from './Category/Flipkart/Flpkrt14';
import Flpkrt15 from './Category/Flipkart/Flpkrt15';

import Pytm1 from './Category/Paytm/Pytm1'
import Pytm2 from './Category/Paytm/Pytm2'
import Pytm3 from './Category/Paytm/Pytm3'
import Pytm4 from './Category/Paytm/Pytm4'
import Pytm5 from './Category/Paytm/Pytm5'
import Pytm6 from './Category/Paytm/Pytm6'
import Pytm7 from './Category/Paytm/Pytm7'
import Pytm8 from './Category/Paytm/Pytm8'
import Pytm9 from './Category/Paytm/Pytm9'
import Pytm10 from './Category/Paytm/Pytm10'
import Pytm11 from './Category/Paytm/Pytm11'
import Pytm12 from './Category/Paytm/Pytm12'
import Pytm13 from './Category/Paytm/Pytm13'
import Pytm14 from './Category/Paytm/Pytm14'


import Ola1 from './Category/Ola/Ola1'
import Ola2 from './Category/Ola/Ola2'
import Ola3 from './Category/Ola/Ola3'
import Ola4 from './Category/Ola/Ola4'
import Ola5 from './Category/Ola/Ola5'
import Ola6 from './Category/Ola/Ola6'
import Ola7 from './Category/Ola/Ola7'
import Ola8 from './Category/Ola/Ola8'
import Ola9 from './Category/Ola/Ola9'
import Ola10 from './Category/Ola/Ola10'
import Ola11 from './Category/Ola/Ola11'
import Ola12 from './Category/Ola/Ola12'
import Ola13 from './Category/Ola/Ola13'
import Ola14 from './Category/Ola/Ola14'
import Ola15 from './Category/Ola/Ola15'


import Cis1 from './Category/Cisco/Cis1'
import Cis2 from './Category/Cisco/Cis2'
import Cis3 from './Category/Cisco/Cis3'
import Cis4 from './Category/Cisco/Cis4'
import Cis5 from './Category/Cisco/Cis5'
import Cis6 from './Category/Cisco/Cis6'
import Cis7 from './Category/Cisco/Cis7'
import Cis8 from './Category/Cisco/Cis8'
import Cis9 from './Category/Cisco/Cis9'
import Cis10 from './Category/Cisco/Cis10'
import Cis11 from './Category/Cisco/Cis11'
import Cis12 from './Category/Cisco/Cis12'
import Cis13 from './Category/Cisco/Cis13'
import Cis14 from './Category/Cisco/Cis14'

import Smsung1 from './Category/Samsung/Smsung1'
import Smsung2 from './Category/Samsung/Smsung2'
import Smsung3 from './Category/Samsung/Smsung3'
import Smsung4 from './Category/Samsung/Smsung4'
import Smsung5 from './Category/Samsung/Smsung5'
import Smsung6 from './Category/Samsung/Smsung6'
import Smsung7 from './Category/Samsung/Smsung7'
import Smsung8 from './Category/Samsung/Smsung8'
import Smsung9 from './Category/Samsung/Smsung9'
import Smsung10 from './Category/Samsung/Smsung10'
import Smsung11 from './Category/Samsung/Smsung11'
import Smsung12 from './Category/Samsung/Smsung12'
import Smsung13 from './Category/Samsung/Smsung13'
import Smsung14 from './Category/Samsung/Smsung14'



import Qual1 from './Category/Qualcomm/Qual1'
import Qual2 from './Category/Qualcomm/Qual2'
import Qual3 from './Category/Qualcomm/Qual3'
import Qual4 from './Category/Qualcomm/Qual4'
import Qual5 from './Category/Qualcomm/Qual5'
import Qual6 from './Category/Qualcomm/Qual6'
import Qual7 from './Category/Qualcomm/Qual7'
import Qual8 from './Category/Qualcomm/Qual8'
import Qual9 from './Category/Qualcomm/Qual9'

import Qual11 from './Category/Qualcomm/Qual11'
import Qual12 from './Category/Qualcomm/Qual12'
import Qual13 from './Category/Qualcomm/Qual13'
import Qual14 from './Category/Qualcomm/Qual14'
import Qual15 from './Category/Qualcomm/Qual15'



import Snp1 from './Category/Snapdeal/Snp3'
import Snp2 from './Category/Snapdeal/Snp4'
import Snp3 from './Category/Snapdeal/Snp5'
import Snp4 from './Category/Snapdeal/Snp6'
import Snp5 from './Category/Snapdeal/Snp7'
import Snp6 from './Category/Snapdeal/Snp8'
import Snp7 from './Category/Snapdeal/Snp9'
import Snp8 from './Category/Snapdeal/Snp10'
import Snp9 from './Category/Snapdeal/Snp11'
import Snp10 from './Category/Snapdeal/Snp12'
import Snp11 from './Category/Snapdeal/Snp13'
import Snp12 from './Category/Snapdeal/Snp14'
import Snp13 from './Category/Snapdeal/Snp15'

import Radmap_design from './Category/Roadmap/Radmap_design';
import Software_dev from './Category/Roadmap/Software_dev';
import Dba from './Category/Roadmap/Dba'
import Che from './Category/Roadmap/Che';
import Da from './Category/Roadmap/Da';
import Cna from './Category/Roadmap/Cna';
import Web_dev from './Category/Roadmap/Web_dev';
import Project_man from './Category/Roadmap/Project_man';
import Blog from './Category/Roadmap/Blog';
import Content_dev from './Category/Roadmap/Content_dev';
import Author from './Category/Roadmap/Author';
import Online from './Category/Roadmap/Online';
import Web_designer from './Category/Roadmap/Web_designer';
import Startup from './Category/Roadmap/Startup';
import Marketing from './Category/Roadmap/Marketing';
import Prof from './Category/Roadmap/Prof';
import PCB from './Category/Roadmap/PCB';
import Homes from './Config/Home'
import About from './Heading/About'


import Front from './Blogs/Front-end'
import Backend from './Blogs/Backend';
import Ai from './Blogs/Ai';
import FullStk from './Blogs/FullStk';
import DataSci from './Blogs/DataSci';
import DataAnal from './Blogs/DataAnal';
import Android from './Blogs/Android';
import Blockchain from './Blogs/Blockchain';
import Network from './Blogs/Network';
import Admin from './Blogs/Admin';
import Cpp from './Category/Languages/Cpp';
import Java1 from './Category/Languages/Java1';

// import Index from './Category/DataStructure/Index';
// import ArrayD from './Category/DataStructure/ArrayD'
// import ArrayIntro from './Category/DataStructure/ArrayIntro';
// import ArrayIntroD from './Category/DataStructure/Intoduction/ArrayIntroD';
// import ArrDC from './Category/DataStructure/Intoduction/ArrDC';
// import ArrDJ from './Category/DataStructure/Intoduction/ArrDJ';
// import ArrDP from './Category/DataStructure/Intoduction/ArrDP';
// import ArrRotInd from './Category/DataStructure/ArrRot/ArrRotInd';
// import ArrRot1 from './Category/DataStructure/ArrRot/ArrRot1';
// import ArrRot2 from './Category/DataStructure/ArrRot/ArrRot2';
// import ArrRot3 from './Category/DataStructure/ArrRot/ArrRot3';
// import ArrRot4 from './Category/DataStructure/ArrRot/ArrRot4';
// import ArrRot5 from './Category/DataStructure/ArrRot/ArrRot5';
// import ArrRot6 from './Category/DataStructure/ArrRot/ArrRot6';
// import RearrInd from './Category/DataStructure/ArrRearr/RearrInd';
// import Rearr1 from './Category/DataStructure/ArrRearr/Rearr1';
// import Rearr2 from './Category/DataStructure/ArrRearr/Rearr2';
// import Rearr14 from './Category/DataStructure/ArrRearr/Rearr14';
// import Rearr3 from './Category/DataStructure/ArrRearr/Rearr3';
// import Rearr4 from './Category/DataStructure/ArrRearr/Rearr4';
// import Rearr5 from './Category/DataStructure/ArrRearr/Rearr5';
// import Rearr6 from './Category/DataStructure/ArrRearr/Rearr6';
// import Rearr7 from './Category/DataStructure/ArrRearr/Rearr7';
// import Rearr8 from './Category/DataStructure/ArrRearr/Rearr8';
// import Rearr9 from './Category/DataStructure/ArrRearr/Rearr9';
// import Rearr10 from './Category/DataStructure/ArrRearr/Rearr10';
// import Rearr11 from './Category/DataStructure/ArrRearr/Rearr11';
// import Rearr12 from './Category/DataStructure/ArrRearr/Rearr12';
// import Rearr13 from './Category/DataStructure/ArrRearr/Rearr13';

// import ArrOSind from './Category/DataStructure/ArrOS/ArrOSind';
// import ArrOS1 from './Category/DataStructure/ArrOS/ArrOS1';
// import ArrOS2 from './Category/DataStructure/ArrOS/ArrOS2';
// import ArrOS3 from './Category/DataStructure/ArrOS/ArrOS3';
// import ArrOS4 from './Category/DataStructure/ArrOS/ArrOS4';
// import ArrOS5 from './Category/DataStructure/ArrOS/ArrOS5';
// import ArrOS6 from './Category/DataStructure/ArrOS/ArrOS6';
// import ArrOS7 from './Category/DataStructure/ArrOS/ArrOS7';
// import ArrOS8 from './Category/DataStructure/ArrOS/ArrOS8';
// import ArrOS9 from './Category/DataStructure/ArrOS/ArrOS9';
// import ArrOS10 from './Category/DataStructure/ArrOS/ArrOS10';
// import ArrOS11 from './Category/DataStructure/ArrOS/ArrOS11';
// import ArrOS12 from './Category/DataStructure/ArrOS/ArrOS12';
// import ArrOS13 from './Category/DataStructure/ArrOS/ArrOS13';

// import ArrRqInd from './Category/DataStructure/ArrRq/ArrRqInd';
// import ArrRq1 from './Category/DataStructure/ArrRq/ArrRq1';
// import ArrRq2 from './Category/DataStructure/ArrRq/ArrRq2';
// import ArrRq3 from './Category/DataStructure/ArrRq/ArrRq3';
// import ArrRq4 from './Category/DataStructure/ArrRq/ArrRq4';
// import ArrRq5 from './Category/DataStructure/ArrRq/ArrRq5';
// import ArrRq6 from './Category/DataStructure/ArrRq/ArrRq6';
// import ArrRq7 from './Category/DataStructure/ArrRq/ArrRq7';
// import ArrRq8 from './Category/DataStructure/ArrRq/ArrRq8';
// import ArrRq9 from './Category/DataStructure/ArrRq/ArrRq9';
// import ArrRq10 from './Category/DataStructure/ArrRq/ArrRq10';
// import ArrRq11 from './Category/DataStructure/ArrRq/ArrRq11';
// import ArrRq12 from './Category/DataStructure/ArrRq/ArrRq12';
// import ArrRq13 from './Category/DataStructure/ArrRq/ArrRq13';

// import ArrSSind from './Category/DataStructure/ArrSS.jsx/ArrSSind';
// import ArrSS1 from './Category/DataStructure/ArrSS.jsx/ArrSS1';
// import ArrSS2 from './Category/DataStructure/ArrSS.jsx/ArrSS2';
// import ArrSS3 from './Category/DataStructure/ArrSS.jsx/ArrSS3';
// import ArrSS4 from './Category/DataStructure/ArrSS.jsx/ArrSS4';
// import ArrSS5 from './Category/DataStructure/ArrSS.jsx/ArrSS5';
// import ArrSS6 from './Category/DataStructure/ArrSS.jsx/ArrSS6';
// import ArrSS7 from './Category/DataStructure/ArrSS.jsx/ArrSS7';
// import ArrSS8 from './Category/DataStructure/ArrSS.jsx/ArrSS8';
// import ArrSS9 from './Category/DataStructure/ArrSS.jsx/ArrSS9';
// import ArrSS10 from './Category/DataStructure/ArrSS.jsx/ArrSS10';
// import ArrSS11 from './Category/DataStructure/ArrSS.jsx/ArrSS11';
// import ArrSS12 from './Category/DataStructure/ArrSS.jsx/ArrSS12';
// import ArrSS13 from './Category/DataStructure/ArrSS.jsx/ArrSS13';

// import ArrOPInd from './Category/DataStructure/ArrOP/ArrOPInd';
// import ArrOP1 from './Category/DataStructure/ArrOP/ArrOP1';
// import ArrOP2 from './Category/DataStructure/ArrOP/ArrOP2';
// import ArrOP3 from './Category/DataStructure/ArrOP/ArrOP3';
// import ArrOP4 from './Category/DataStructure/ArrOP/ArrOP4';
// import ArrOP5 from './Category/DataStructure/ArrOP/ArrOP5';
// import ArrOP6 from './Category/DataStructure/ArrOP/ArrOP6';
// import ArrOP7 from './Category/DataStructure/ArrOP/ArrOP7';
// import ArrOP8 from './Category/DataStructure/ArrOP/ArrOP8';
// import ArrOP9 from './Category/DataStructure/ArrOP/ArrOP9';
// import ArrOP10 from './Category/DataStructure/ArrOP/ArrOP10';
// import ArrOP11 from './Category/DataStructure/ArrOP/ArrOP11';
// import ArrOP12 from './Category/DataStructure/ArrOP/ArrOP12';
// import ArrOP13 from './Category/DataStructure/ArrOP/ArrOP13';

// import ArrMatInd from './Category/DataStructure/ArrMat/ArrMatInd';
// import ArrMat1 from './Category/DataStructure/ArrMat/ArrMat1';
// import ArrMat2 from './Category/DataStructure/ArrMat/ArrMat2';
// import ArrMat3 from './Category/DataStructure/ArrMat/ArrMat3';
// import ArrMat4 from './Category/DataStructure/ArrMat/ArrMat4';
// import ArrMat5 from './Category/DataStructure/ArrMat/ArrMat5';
// import ArrMat6 from './Category/DataStructure/ArrMat/ArrMat6';
// import ArrMat7 from './Category/DataStructure/ArrMat/ArrMat7';
// import ArrMat8 from './Category/DataStructure/ArrMat/ArrMat8';
// import ArrMat9 from './Category/DataStructure/ArrMat/ArrMat9';
// import ArrMat10 from './Category/DataStructure/ArrMat/ArrMat10';
// import ArrMat11 from './Category/DataStructure/ArrMat/ArrMat11';
// import ArrMat12 from './Category/DataStructure/ArrMat/ArrMat12';
// import ArrMat13 from './Category/DataStructure/ArrMat/ArrMat13';
// import ArrMat from './Category/DataStructure/ArrMat/ArrMatInd';

// import BinInd from './Category/DataStructure/BinaryTree/Ind';
// import BtCCInd from './Category/DataStructure/BinaryTree/CC/BtCCInd';
// import BtCC1 from './Category/DataStructure/BinaryTree/CC/BtCC1';
// import BtCC2 from './Category/DataStructure/BinaryTree/CC/BtCC2';
// import BtCC3 from './Category/DataStructure/BinaryTree/CC/BtCC3';
// import BtCC4 from './Category/DataStructure/BinaryTree/CC/BtCC4';
// import BtCC5 from './Category/DataStructure/BinaryTree/CC/BtCC5';
// import BtCC6 from './Category/DataStructure/BinaryTree/CC/BtCC6';
// import BtCC7 from './Category/DataStructure/BinaryTree/CC/BtCC7';
// import BtCC8 from './Category/DataStructure/BinaryTree/CC/BtCC8';
// import BtCC9 from './Category/DataStructure/BinaryTree/CC/BtCC9';
// import BtCC10 from './Category/DataStructure/BinaryTree/CC/BtCC10';

function Meny()
{
  useDocumentTitle('Category');
  return (<> <Heading />    <Cards />    <ScrollToTop /> <Footer />    </>)
}
function Cq()
{
  useDocumentTitle('C-Course');
  return (<> <Heading />   <CB />     <ScrollToTop /> <Footer />

  </>)

}
function Py()
{
  useDocumentTitle('Python-Course');
  return (<>  <Heading />    <Python1 />    <ScrollToTop /> <Footer />    </>)

}
function Jav()
{
  useDocumentTitle('Java-Course');
  return (<>  <Heading />    <Java1 />    <ScrollToTop /> <Footer />    </>)

}
function Cps()
{
  useDocumentTitle('C++-Course');
  return (<>   <Heading />    <Cpp />    <ScrollToTop /> <Footer />    </>)
}
function C_intro()
{
  useDocumentTitle('C++-Introduction');
  return (<>    <Heading />
    <Intro />
    <ScrollToTop /> <Footer />   </>)
}
function Bas()
{
  useDocumentTitle('Basic Computer Components');
  return (<>    <Heading />    <BCC />    <ScrollToTop /> <Footer />   </>)
}
function Chart()
{
  useDocumentTitle('FlowChart');
  return (<>    <Heading />    <Flow />    <ScrollToTop /> <Footer />   </>)
}
function Psu()
{
  useDocumentTitle('Pseudocode in C');
  return (<>    <Heading />    <Psudo />    <ScrollToTop /> <Footer />   </>)
}
function Ten()
{
  useDocumentTitle('Print a number 10 time using flow chart and Pseudocode');
  return (<>    <Heading />    <Tentime />    <ScrollToTop /> <Footer />   </>)
}
function Temps()
{
  useDocumentTitle('Template');
  return (<>    <Heading />    <Template />    <ScrollToTop /> <Footer />   </>)
}
function Fun()
{
  useDocumentTitle('Functions & its types');
  return (<>    <Heading />    <Fd />   <ScrollToTop /> <Footer />   </>)
}
function Dat()
{
  useDocumentTitle('Data types');
  return (<>    <Heading />    <Data />   <ScrollToTop /> <Footer />   </>)
}
function Scope()
{
  useDocumentTitle('Scopes of Variable');
  return (<>    <Heading />    <Scopes />   <ScrollToTop /> <Footer />   </>)
}
function Bts()
{
  useDocumentTitle('Behind The Scenes');
  return (<>    <Heading />    <Behind />   <ScrollToTop /> <Footer />   </>)
}
function Wrd()
{
  useDocumentTitle('Keywords');
  return (<>    <Heading />    <Keyword />   <ScrollToTop /> <Footer />   </>)
}
function Lo()
{
  useDocumentTitle('Loops');
  return (<>    <Heading />    <Loop />   <ScrollToTop /> <Footer />   </>)
}
function T_p()
{
  useDocumentTitle('Ternary Operator');
  return (<>    <Heading />    <T_o />   <ScrollToTop /> <Footer />   </>)
}
function T_t()
{
  useDocumentTitle('Print NooB-Geeks ten 10 times.');
  return (<>    <Heading />    <Fourteen />  <ScrollToTop /> <Footer />   </>)
}
function Ma()
{
  useDocumentTitle('Can main function of any other data types');
  return (<>    <Heading />    <Fifteen />  <ScrollToTop /> <Footer />   </>)
}
function Odd()
{
  useDocumentTitle('Print sum of odd number till N');
  return (<>    <Heading />    <Seventeen />  <ScrollToTop /> <Footer />   </>)
}
function Eighte()
{
  useDocumentTitle('Check Prime or Not');
  return (<>    <Heading />    <Eighteen />  <ScrollToTop /> <Footer />   </>)
}
function Nint()
{
  useDocumentTitle('Print number Pyramind Pattern');
  return (<>    <Heading />    <Nineteen />  <ScrollToTop /> <Footer />   </>)
}
function Twent()
{
  useDocumentTitle('Print alphabet pyramid pattern');
  return (<>    <Heading />    <Twenty />  <ScrollToTop /> <Footer />   </>)
}
function TwentO()
{
  useDocumentTitle('Print diamond Pyramind Pattern');
  return (<>    <Heading />    <Twenty_one />  <ScrollToTop /> <Footer />   </>)
}
function TwentTw()
{
  useDocumentTitle('Print diamond Pyramind Pattern');
  return (<>    <Heading />    <Twenty_one />  <ScrollToTop /> <Footer />   </>)
}
function Cod()
{
  useDocumentTitle('Concepts of coding');
  return (<>    <Heading />    <Twenty_four />  <ScrollToTop /> <Footer />   </>)
}
function Tf()
{
  useDocumentTitle('Print largest of N');
  return (<>    <Heading />    <Twenty_five />  <ScrollToTop /> <Footer />   </>)
}
function Tsi()
{
  useDocumentTitle('Print sq rt of N');
  return (<>    <Heading />    <Twenty_six />  <ScrollToTop /> <Footer />   </>)
}
function Ts()
{
  useDocumentTitle('Find Mean of given numbers');
  return (<>    <Heading />    <Twenty_seven />  <ScrollToTop /> <Footer />   </>)
}
function Te()
{
  useDocumentTitle('Convert Decimal to binary');
  return (<>    <Heading />    <Twenty_eight />  <ScrollToTop /> <Footer />   </>)
}
function Ar()
{
  useDocumentTitle('Arrays in C');
  return (<>    <Heading />    <Array />  <ScrollToTop /> <Footer />   </>)
}
function Th()
{
  useDocumentTitle('Print n number using array');
  return (<>    <Heading />    <Thirty />  <ScrollToTop /> <Footer />   </>)
}
function Alg()
{
  useDocumentTitle('Algorithm');
  return (<>    <Heading />    <Algo />  <ScrollToTop /> <Footer />   </>)
}
function Bin()
{
  useDocumentTitle('Binary Search in C');
  return (<>    <Heading />    <Binary />  <ScrollToTop /> <Footer />   </>)
}
function Tht()
{
  useDocumentTitle('Linear Search in C');
  return (<>    <Heading />    <Thirty_two />  <ScrollToTop /> <Footer />   </>)
}
function Thf()
{
  useDocumentTitle('Selection Sort in C');
  return (<>    <Heading />    <Thirty_four /> <ScrollToTop /> <Footer />   </>)
}
function Thfi()
{
  useDocumentTitle('Insertion Sort in C');
  return (<>    <Heading />    <Thirty_five /> <ScrollToTop /> <Footer />   </>)
}
function Ths()
{
  useDocumentTitle('Swapping variables in C');
  return (<>    <Heading />    <Thirty_six /> <ScrollToTop /> <Footer />   </>)
}
function Thse()
{
  useDocumentTitle('print ncr number in C');
  return (<>    <Heading />    <Thirty_seven /> <ScrollToTop /> <Footer />   </>)
}
function The()
{
  useDocumentTitle('Program to Merge the Elements of 2 Sorted Array');
  return (<>    <Heading />    <Thirty_eight /> <ScrollToTop /> <Footer />   </>)
}
function Ptr()
{
  useDocumentTitle('Program to Merge the Elements of 2 Sorted Array');
  return (<>    <Heading />    <Pointer /> <ScrollToTop /> <Footer />   </>)
}
function Fo()
{
  useDocumentTitle('Program to Merge the Elements of 2 Sorted Array');
  return (<>    <Heading />   <Forty_one />  <ScrollToTop /> <Footer />   </>)
}
function Td()
{
  useDocumentTitle('Two Dimensional Array in C');
  return (<>    <Heading />   <Two_D />  <ScrollToTop /> <Footer />   </>)
}
function Rot()
{
  useDocumentTitle('Rotate an array by 90 degree');
  return (<>    <Heading />   <Rotate />  <ScrollToTop /> <Footer />   </>)
}
function St()
{
  useDocumentTitle('Rotate an array by 90 degree');
  return (<>    <Heading />   <String />  <ScrollToTop /> <Footer />   </>)
}
function St_re()
{
  useDocumentTitle('Reverse the String in C');
  return (<>    <Heading />   <String_rev />  <ScrollToTop /> <Footer />   </>)
}
function Ft_o()
{
  useDocumentTitle('sum of n numbers using recurssion in C');
  return (<>    <Heading />   <Fifty_one />  <ScrollToTop /> <Footer />   </>)
}
function Ft_t()
{
  useDocumentTitle('Write a program in C to count total number of alphabets, digits and special characters in a string.');
  return (<>    <Heading />   <Fifty_two />  <ScrollToTop /> <Footer />   </>)
}
function Ft_th()
{
  useDocumentTitle('Write a program in C to extract a substring from a given string.');
  return (<>    <Heading />   <Fifty_three />  <ScrollToTop /> <Footer />   </>)
}
function Ft_fo()
{
  useDocumentTitle('Write a program in C to convert a string to uppercase .');
  return (<>    <Heading />   <Fifty_four />  <ScrollToTop /> <Footer />   </>)
}
function Ft_fi()
{
  useDocumentTitle('Write a program in C to split string by space into words. ');
  return (<>    <Heading />   <Fifty_five />  <ScrollToTop /> <Footer />   </>)
}
function Ft_si()
{
  useDocumentTitle('Recurssion ');
  return (<>    <Heading />   <Fifty_six />  <ScrollToTop /> <Footer />   </>)
}
function Ft_se()
{
  useDocumentTitle('Factorial using Recurssion');
  return (<>    <Heading />   <Fifty_seven />  <ScrollToTop /> <Footer />   </>)
}
function Ft_e()
{
  useDocumentTitle('Sum of Natural Numbers using Recursion');
  return (<>    <Heading />   <Fifty_eight />  <ScrollToTop /> <Footer />   </>)
}
function Ft_n()
{
  useDocumentTitle('Array reverse Using Recurssion');
  return (<>    <Heading />   <Fifty_Nine />  <ScrollToTop /> <Footer />   </>)
}
function Si()
{
  useDocumentTitle('Binary search using recursion');
  return (<>    <Heading />   <Sixty />  <ScrollToTop /> <Footer />   </>)
}
function Rim()
{
  useDocumentTitle('Rat in a maze');
  return (<>    <Heading />   <Rat_in_Maze />  <ScrollToTop /> <Footer />   </>)
}
function Sta()
{
  useDocumentTitle('Stack');
  return (<>    <Heading />   <Stack />  <ScrollToTop /> <Footer />   </>)
}
function Qu()
{
  useDocumentTitle('Queue');
  return (<>    <Heading />   <Queue />  <ScrollToTop /> <Footer />   </>)
}
function Ll()
{
  useDocumentTitle('Linked List');
  return (<>    <Heading />   <Linked_list />  <ScrollToTop /> <Footer />   </>)
}
function St_t()
{
  useDocumentTitle('N-Queen Problem in C');
  return (<>    <Heading />   <Sixty_two />  <ScrollToTop /> <Footer />   </>)
}
function St_th()
{
  useDocumentTitle('Recursion Permutation Lexicogrpahical Order in C');
  return (<>    <Heading />   <Sixty_three />  <ScrollToTop /> <Footer />   </>)
}
function Dma()
{
  useDocumentTitle('Dynamic Memory Allocation in C');
  return (<>    <Heading />   <DMA />  <ScrollToTop /> <Footer />   </>)
}
function Si_f()
{
  useDocumentTitle('Arrange the string in Dictionary order larger');
  return (<>    <Heading />   <Sixty_four />  <ScrollToTop /> <Footer />   </>)
}



function Py_intro()
{
  useDocumentTitle('Python Introduction');
  return (<>    <Heading />   <Introduction />  <ScrollToTop /> <Footer />   </>)
}
function Py_io()
{
  useDocumentTitle('Python Introduction');
  return (<>    <Heading />   <Input_Output />  <ScrollToTop /> <Footer />   </>)
}
function Py_var()
{
  useDocumentTitle('Python Variables');
  return (<>    <Heading />   <Varibales />  <ScrollToTop /> <Footer />   </>)
}
function Py_loop()
{
  useDocumentTitle('Python Loop');
  return (<>    <Heading />   <Loops />  <ScrollToTop /> <Footer />   </>)
}
function Py_Ap()
{
  useDocumentTitle('Python Alphabet Pattern');
  return (<>    <Heading />   <Alphabet_pattern />  <ScrollToTop /> <Footer />   </>)
}
function Py_Np()
{
  useDocumentTitle('Python Alphabet Pattern');
  return (<>    <Heading />   <Number_pattern />  <ScrollToTop /> <Footer />   </>)
}
function Py_dt()
{
  useDocumentTitle('Python Data types');
  return (<>    <Heading />   <Data_types />  <ScrollToTop /> <Footer />   </>)
}
function Py_str()
{
  useDocumentTitle('Python String');
  return (<>    <Heading />   <Strings />  <ScrollToTop /> <Footer />   </>)
}
function Py_ls()
{
  useDocumentTitle('Least Frequent Character in String');
  return (<>    <Heading />   <Least_string />  <ScrollToTop /> <Footer />   </>)
}
function Py_sp()
{
  useDocumentTitle('Program to convert the given string from snake Case to Pascal case');
  return (<>    <Heading />   <Snake_Pascal />  <ScrollToTop /> <Footer />   </>)
}
function Py_rs()
{
  useDocumentTitle('Reverse string in Python');
  return (<>    <Heading />   <Reverse_string />  <ScrollToTop /> <Footer />   </>)
}
function Py_pal()
{
  useDocumentTitle('Palindrome Program in Python');
  return (<>    <Heading />   <Palindrom />  <ScrollToTop /> <Footer />   </>)
}
function Py_sub()
{
  useDocumentTitle('Find Substring of a String in Python');
  return (<>    <Heading />   <Substr />  <ScrollToTop /> <Footer />   </>)
}
function Py_li()
{
  useDocumentTitle('List in Python');
  return (<>    <Heading />   <List />  <ScrollToTop /> <Footer />   </>)
}
function Py_rl()
{
  useDocumentTitle('Reverse List in Python');
  return (<>    <Heading />   <Reverse_list />  <ScrollToTop /> <Footer />   </>)
}
function Py_sl()
{
  useDocumentTitle('find second largest number in a list');
  return (<>    <Heading />   <Second_largest />  <ScrollToTop /> <Footer />   </>)
}
function Py_sli()
{
  useDocumentTitle('Sort the values of first list using second list in Python');
  return (<>    <Heading />   <Sort_list />  <ScrollToTop /> <Footer />   </>)
}
function Py_cl()
{
  useDocumentTitle('Cloning or Copying a list ');
  return (<>    <Heading />   <Cloning />  <ScrollToTop /> <Footer />   </>)
}
function Py_tu()
{
  useDocumentTitle('Tuple in Python ');
  return (<>    <Heading />   <Tuple /> <ScrollToTop /> <Footer />   </>)
}
function Py_tu_c()
{
  useDocumentTitle('Create a list of tuples from given list having number and its cube in each tuple ');
  return (<>    <Heading />   <Tuple_Cube /> <ScrollToTop /> <Footer />   </>)
}
function Py_tu_ct()
{
  useDocumentTitle('Closest Pair to Kth index element in Tuple ');
  return (<>    <Heading />   <Closest_Tuple /> <ScrollToTop /> <Footer />   </>)
}
function Py_tu_pc()
{
  useDocumentTitle('All pair combinations of 2 tuples');
  return (<>    <Heading />   <Pair_comb /> <ScrollToTop /> <Footer />   </>)
}
function Py_tu_nt()
{
  useDocumentTitle('Convert Nested Tuple to Custom Key Dictionary');
  return (<>    <Heading /> <Nested_tuple />  <ScrollToTop /> <Footer />   </>)
}
function Py_tu_st()
{
  useDocumentTitle('Sort a list of tuples by second Item');
  return (<>    <Heading /> <Sort_two /> <ScrollToTop /> <Footer />   </>)
}
function Py_st()
{
  useDocumentTitle('Sets in Python');
  return (<>    <Heading /> <Sets /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic()
{
  useDocumentTitle('Dictionary in Python');
  return (<>    <Heading /> <Dictionary /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic_un()
{
  useDocumentTitle('Extract Unique values dictionary values');
  return (<>    <Heading /> <Unique_dict /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic_kd()
{
  useDocumentTitle('Ways to remove a key from dictionary');
  return (<>    <Heading /> <Key_dict /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic_mk()
{
  useDocumentTitle('Handling missing keys in Python dictionaries ');
  return (<>    <Heading /> <Missing_key /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic_mc()
{
  useDocumentTitle('Python Dictionary to find mirror characters in a string');
  return (<>    <Heading /> <Mirror_char /> <ScrollToTop /> <Footer />   </>)
}
function Py_dic_pw()
{
  useDocumentTitle('Possible Words using given characters in Python');
  return (<>    <Heading /> <Possible_words /> <ScrollToTop /> <Footer />   </>)
}
function Py_arr()
{
  useDocumentTitle('Array in Python');
  return (<>    <Heading /> <Arrays /> <ScrollToTop /> <Footer />   </>)
}
function Py_que()
{
  useDocumentTitle('N_Queen in Python');
  return (<>    <Heading /> <N_queen /> <ScrollToTop /> <Footer />   </>)
}
function Py_rm()
{
  useDocumentTitle('Rat in a Maze in Python');
  return (<>    <Heading /> <Rat_maze /> <ScrollToTop /> <Footer />   </>)
}
function Py_cp()
{
  useDocumentTitle('Check prime or not in Python');
  return (<>    <Heading /> <Prime /> <ScrollToTop /> <Footer />   </>)
}
function Py_op()
{
  useDocumentTitle('OOPS in Python');
  return (<>    <Heading /> <Oops /> <ScrollToTop /> <Footer />   </>)
}
function Py_co()
{
  useDocumentTitle('class and object in Python');
  return (<>    <Heading /> <Class_object /> <ScrollToTop /> <Footer />   </>)
}
function Py_dh()
{
  useDocumentTitle('Data hiding and Print Object in Python');
  return (<>    <Heading /> <Data_object /> <ScrollToTop /> <Footer />   </>)
}
function Py_inh()
{
  useDocumentTitle('Inheritance in Python');
  return (<>    <Heading /> <Inheritance /> <ScrollToTop /> <Footer />   </>)
}
function Py_poly()
{
  useDocumentTitle('Polymorphism in Python');
  return (<>    <Heading /> <Polymorphism /> <ScrollToTop /> <Footer />   </>)
}
function Py_const()
{
  useDocumentTitle('Constructors in Python');
  return (<>    <Heading /> <Constructors /> <ScrollToTop /> <Footer />   </>)
}
function Py_dest()
{
  useDocumentTitle('Destructors in Python');
  return (<>    <Heading /> <Destructors /> <ScrollToTop /> <Footer />   </>)
}
function Py_meta()
{
  useDocumentTitle('Metaprogramming in Python');
  return (<>    <Heading /> <Metaprogramming /> <ScrollToTop /> <Footer />   </>)
}
function Py_ca()
{
  useDocumentTitle('Class Attributes in Python');
  return (<>    <Heading /> <Class_attributes /> <ScrollToTop /> <Footer />   </>)
}
function Py_ex()
{
  useDocumentTitle('Exception in Python');
  return (<>    <Heading /> <Exception /> <ScrollToTop /> <Footer />   </>)
}
function Py_ud()
{
  useDocumentTitle('User Define in Python');
  return (<>    <Heading /> <User_define /> <ScrollToTop /> <Footer />   </>)
}
function Py_cua()
{
  useDocumentTitle('Defining Clean Up Actions in Python');
  return (<>    <Heading />  <Clean /> <ScrollToTop /> <Footer />   </>)
}
function Py_pte()
{
  useDocumentTitle(' try Except in Python');
  return (<>    <Heading />  <Try /> <ScrollToTop /> <Footer />   </>)
}
function Py_dq()
{
  useDocumentTitle(' Dequeue in Python');
  return (<>    <Heading />  <Deque /> <ScrollToTop /> <Footer />   </>)
}
function Py_hp()
{
  useDocumentTitle(' Heap in Python');
  return (<>    <Heading />  <Heap /> <ScrollToTop /> <Footer />   </>)
}
function Py_np()
{
  useDocumentTitle(' Numpy in Python');
  return (<>    <Heading />  <Numpy /> <ScrollToTop /> <Footer />   </>)
}
function Py_sss()
{
  useDocumentTitle(' Sorting searching and counting');
  return (<>    <Heading />  <Sorting /> <ScrollToTop /> <Footer />   </>)
}
function Py_pan()
{
  useDocumentTitle(' Pandas');
  return (<>    <Heading />  <Pandas /> <ScrollToTop /> <Footer />   </>)
}
function Py_ps()
{
  useDocumentTitle(' Pandas series');
  return (<>    <Heading /> <P_series /> <ScrollToTop /> <Footer />   </>)
}
function Py_df()
{
  useDocumentTitle(' creating data frame');
  return (<>    <Heading /> <Data_frame /> <ScrollToTop /> <Footer />   </>)
}
function Py_pc()
{
  useDocumentTitle('Conversion data frame');
  return (<>    <Heading /> <Conversion /> <ScrollToTop /> <Footer />   </>)
}
function Py_ml()
{
  useDocumentTitle('Machine Learning');
  return (<>    <Heading /> <Machine_learn /> <ScrollToTop /> <Footer />   </>)
}
function Py_mod()
{
  useDocumentTitle('Modules');
  return (<>    <Heading /> <Modules /> <ScrollToTop /> <Footer />   </>)
}
function Py_cal()
{
  useDocumentTitle('Calender Modules');
  return (<>    <Heading /> <Calender /> <ScrollToTop /> <Footer />   </>)
}
function Py_os()
{
  useDocumentTitle('Os Modules');
  return (<>    <Heading /> <Os_module /> <ScrollToTop /> <Footer />   </>)
}
function Py_db()
{
  useDocumentTitle('Python with Mongo DB');
  return (<>    <Heading /> <Mongo_db /> <ScrollToTop /> <Footer />   </>)
}
function Py_imp()
{
  useDocumentTitle('Import Modules');
  return (<>    <Heading /> <Impot /> <ScrollToTop /> <Footer />   </>)
}
function Py_djan()
{
  useDocumentTitle('Django');
  return (<>    <Heading /> <Django /> <ScrollToTop /> <Footer />   </>)
}
function Py_dta_anal()
{
  useDocumentTitle('Data Analysis');
  return (<>    <Heading /> <Data_anal /> <ScrollToTop /> <Footer />   </>)
}



function Cpp_intro()
{
  useDocumentTitle('C++ - Introduction');
  return (<>    <Heading /> <Introd /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_bcc()
{
  useDocumentTitle('C++ - Basics of Computer Concepts');
  return (<>    <Heading /> <Bcc /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_flow()
{
  useDocumentTitle('C++ - Flowchart and Pseudocode');
  return (<>    <Heading /> <Flow_Pseudo /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_hello()
{
  useDocumentTitle('C++ - Print hello world 10 time by flow chart and pseudocode ');
  return (<>    <Heading /> <Hello /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_pri()
{
  useDocumentTitle('C++ - Check Prime or not by flow  chart and pseudocode');
  return (<>    <Heading /> <Primes /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_sum()
{
  useDocumentTitle('C++ - Sum of N natural numbers by flow chart and pseudocode');
  return (<>    <Heading /> <Sum_of_n /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_concept()
{
  useDocumentTitle('C++ - Concept of Coding');
  return (<>    <Heading /> <Concept /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_temp()
{
  useDocumentTitle('C++ - Template ');
  return (<>    <Heading /> <Temp /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_kwd()
{
  useDocumentTitle('C++ - Keywords Variable and Constant');
  return (<>    <Heading /> <Varaible_const /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_loop()
{
  useDocumentTitle('C++ - Loop');
  return (<>    <Heading /> <Loopse /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_even()
{
  useDocumentTitle('Cpp program to print all Even and Odd numbers from 1 to N');
  return (<>    <Heading /> <Odd_even /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_ap()
{
  useDocumentTitle('C++ - Program to print Arithmetic Progression series');
  return (<>    <Heading /> <Ap /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_primed()
{
  useDocumentTitle('C++ - Write a program to check whether a number is prime or not');
  return (<>    <Heading /> <Primed /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_d_b()
{
  useDocumentTitle('C++ -Program for Decimal to Binary Conversion');
  return (<>    <Heading /> <D_B /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_cr()
{
  useDocumentTitle('C++ - Program to calculate value of nCr');
  return (<>    <Heading /> <Cr /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_alp()
{
  useDocumentTitle('C++ - Alphabet pattern');
  return (<>    <Heading /> <Alp /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_dt()
{
  useDocumentTitle('C++ - Data types');
  return (<>    <Heading /> <D_t /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_arr()
{
  useDocumentTitle('C++ - Array');
  return (<>    <Heading /> <Arr /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_arr_rev()
{
  useDocumentTitle('C++ -Write a program to reverse an array or string');
  return (<>    <Heading /> <Arr_rev /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_linear()
{
  useDocumentTitle('C++ -Write a program to do linear search');
  return (<>    <Heading /> <Cp_linear /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_bubble()
{
  useDocumentTitle('C++ -Write a program to do linear search');
  return (<>    <Heading /> <Cp_bubble /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_selection()
{
  useDocumentTitle('C++ -Write a program to do selection sort');
  return (<>    <Heading /> <Cp_selection /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_ptr()
{
  useDocumentTitle('C++ - Pointer');
  return (<>    <Heading /> <Cp_pointer /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_da()
{
  useDocumentTitle('C++ - Default Argument');
  return (<>    <Heading /> <Cp_default /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_str()
{
  useDocumentTitle('C++ - String');
  return (<>    <Heading /> <Cp_str /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_rot()
{
  useDocumentTitle('Rotate a Matrix Anticlockwise in C++');
  return (<>    <Heading /> <Cp_rot /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_st_rev()
{
  useDocumentTitle('Reverse The string in C++');
  return (<>    <Heading /> <CP_strRev /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_m_str()
{
  useDocumentTitle('Different methods to reverse a  in C++');
  return (<>    <Heading /> <Cp_mStr /> <ScrollToTop /> <Footer />   </>)
}
function Cp_dpStr()
{
  useDocumentTitle('Remove duplicates from a given string in C++');
  return (<>    <Heading /> <Cpp_dpStr /> <ScrollToTop /> <Footer />   </>)
}
function Cpp_perm()
{
  useDocumentTitle('Write a program to print all permutations of a given string');
  return (<>    <Heading /> <Cp_perm /> <ScrollToTop /> <Footer />   </>)
}
function Cp_tog()
{
  useDocumentTitle('Program to toggle all characters in a string');
  return (<>    <Heading /> <Cpp_tog /> <ScrollToTop /> <Footer />   </>)
}
function Cp_recur()
{
  useDocumentTitle('Recurssion in C++');
  return (<>    <Heading /> <Recur /> <ScrollToTop /> <Footer />   </>)
}
function Cp_pal()
{
  useDocumentTitle('Recursive program to check if number is palindrome or not C++');
  return (<>    <Heading /> <Cp_palin /> <ScrollToTop /> <Footer />   </>)
}
function Cp_dma()
{
  useDocumentTitle('Dynamic Memory Allocation');
  return (<>    <Heading /> <Cp_DMA /> <ScrollToTop /> <Footer />   </>)
}
function Cp_rmz()
{
  useDocumentTitle('Rat in a Maze C++');
  return (<>    <Heading /> <Cp_rm /> <ScrollToTop /> <Footer />   </>)
}
function Cp_nq()
{
  useDocumentTitle('C++ Program to Solve N-Queen Problem');
  return (<>    <Heading /> <Cp_nque /> <ScrollToTop /> <Footer />   </>)
}
function Cp_op()
{
  useDocumentTitle('C++ OOPs Concepts');
  return (<>    <Heading /> <Cp_ops /> <ScrollToTop /> <Footer />   </>)
}
function Cp_cls()
{
  useDocumentTitle('C++ Class and its member');
  return (<>    <Heading /> <Cp_clas /> <ScrollToTop /> <Footer />   </>)
}
function Cp_inh()
{
  useDocumentTitle('Difference between Inheritance and Polymorphism');
  return (<>    <Heading /> <C_inh /> <ScrollToTop /> <Footer />   </>)
}
function Cp_lnk()
{
  useDocumentTitle('Linked list in C++');
  return (<>    <Heading /> <Cp_link /> <ScrollToTop /> <Footer />   </>)
}
function Cp_dt()
{
  useDocumentTitle('Delete a Linked List node at a given position');
  return (<>    <Heading /> <Cp_del /> <ScrollToTop /> <Footer />   </>)
}
function Cp_wt()
{
  useDocumentTitle('Write a function to delete a Linked List');
  return (<>    <Heading /> <Cp_whd /> <ScrollToTop /> <Footer />   </>)
}
function Cp_inter()
{
  useDocumentTitle('Write a function to get the intersection point of two Linked Lists');
  return (<>    <Heading /> <Cp_int /> <ScrollToTop /> <Footer />   </>)
}
function Cp_merge()
{
  useDocumentTitle('Merge two sorted linked lists');
  return (<>    <Heading /> <Cp_mrg /> <ScrollToTop /> <Footer />   </>)
}
function Cp_stack()
{
  useDocumentTitle('Stack in C++');
  return (<>    <Heading /> <Cp_stk /> <ScrollToTop /> <Footer />   </>)
}
function Cp_stk_rev()
{
  useDocumentTitle('Reverse stack in C++');
  return (<>    <Heading /> <Cp_st_rev /> <ScrollToTop /> <Footer />   </>)
}
function Cp_inf()
{
  useDocumentTitle('Infix to Postfix');
  return (<>    <Heading /> <Cp_set /> <ScrollToTop /> <Footer />   </>)
}
function Cp_stock()
{
  useDocumentTitle('Stock span problem');
  return (<>    <Heading /> <Cp_sto /> <ScrollToTop /> <Footer />   </>)
}
function Cp_celb()
{
  useDocumentTitle('The Celebrity Problem');
  return (<>    <Heading /> <Cp_celeb /> <ScrollToTop /> <Footer />   </>)
}
function Cp_th()
{
  useDocumentTitle('Tower of Hanoi');
  return (<>    <Heading /> <Cp_Toh /> <ScrollToTop /> <Footer />   </>)
}
function Cp_sort()
{
  useDocumentTitle('Sort the stack');
  return (<>    <Heading /> <Cp_st_srt /> <ScrollToTop /> <Footer />   </>)
}
function Cp_quee()
{
  useDocumentTitle('Queue');
  return (<>    <Heading /> <Cp_que /> <ScrollToTop /> <Footer />   </>)
}
function Cp_vct()
{
  useDocumentTitle('Vector in C++');
  return (<>    <Heading /> <Cp_vec /> <ScrollToTop /> <Footer />   </>)
}
function Cp_mp()
{
  useDocumentTitle('Map in C++');
  return (<>    <Heading /> <Cp_map /> <ScrollToTop /> <Footer />   </>)
}



function Jv_mp()
{
  useDocumentTitle('Introduction To java');
  return (<>    <Heading /> <Jva_Intoduction /> <ScrollToTop /> <Footer />   </>)
}
function Jv_bcc()
{
  useDocumentTitle('Basic of computer operations')
  return (<>    <Heading /> <Jva_BCC /> <ScrollToTop /> <Footer />   </>)
}
function Jv_flow()
{
  useDocumentTitle('Java - Flowchart and Pseudocode')
  return (<>    <Heading /> <Jva_flow /> <ScrollToTop /> <Footer />   </>)
}
function Jv_hello()
{
  useDocumentTitle('Java - Print hello world 10 time by flow chart and pseudocode ')
  return (<>    <Heading /> <Jva_hello /> <ScrollToTop /> <Footer />   </>)
}
function Jv_Prime()
{
  useDocumentTitle('Java - Check Prime or not by flow  chart and pseudocode ')
  return (<>    <Heading /> <Jva_Prime /> <ScrollToTop /> <Footer />   </>)
}
function Jv_sum()
{
  useDocumentTitle('Java - Sum of N natural numbers by flow chart and pseudocode ')
  return (<>    <Heading /> <Jva_sum /> <ScrollToTop /> <Footer />   </>)
}
function Jv_basic()
{
  useDocumentTitle('Java - Basic Concepts of Coding ')
  return (<>    <Heading /> <Jva_Basic /> <ScrollToTop /> <Footer />   </>)
}
function Jv_temp()
{
  useDocumentTitle('Java - Basic and Temmplate ')
  return (<>    <Heading /> <Jva_temp /> <ScrollToTop /> <Footer />   </>)
}
function Jv_IO()
{
  useDocumentTitle('Java - Input and Output ')
  return (<>    <Heading /> <Jva_io /> <ScrollToTop /> <Footer />   </>)
}
function Jv_vck()
{
  useDocumentTitle('Java - Variable and Keywords ')
  return (<>    <Heading /> <Jva_Vck /> <ScrollToTop /> <Footer />   </>)
}
function Jv_main()
{
  useDocumentTitle('Is main method compulsory in Java?')
  return (<>    <Heading /> <Jva_main /> <ScrollToTop /> <Footer />   </>)
}
function Jv_dt()
{
  useDocumentTitle('Data types')
  return (<>    <Heading /> <Jva_dt /> <ScrollToTop /> <Footer />   </>)
}
function Jv_loop()
{
  useDocumentTitle('Loops in Java')
  return (<>    <Heading /> <Jva_loop /> <ScrollToTop /> <Footer />   </>)
}
function Jv_N()
{
  useDocumentTitle('Java Program to Print Natural Numbers from 1 to N')
  return (<>    <Heading /> <Jva_N /> <ScrollToTop /> <Footer />   </>)
}
function Jv_ap()
{
  useDocumentTitle('Java Program to Print Arithmetic Progression 1 to N')
  return (<>    <Heading /> <Jva_ap /> <ScrollToTop /> <Footer />   </>)
}
function Jv_cs()
{
  useDocumentTitle('Java Conditional statement')
  return (<>    <Heading /> <Jva_cs /> <ScrollToTop /> <Footer />   </>)
}
function Jv_checkP()
{
  useDocumentTitle('Java-check Prime or not?')
  return (<>    <Heading /> <Jva_checkP /> <ScrollToTop /> <Footer />   </>)
}
function Jv_Bd()
{
  useDocumentTitle('Java Convert Decimal to Binary')
  return (<>    <Heading /> <Jva_Bd /> <ScrollToTop /> <Footer />   </>)
}
function Jv_nc()
{
  useDocumentTitle('Program to find the value of nCr using method')
  return (<>    <Heading /> <Jva_ncr /> <ScrollToTop /> <Footer />   </>)
}
function Jv_Pattern()
{
  useDocumentTitle('Program to print the Patterns')
  return (<>    <Heading /> <Jva_Pattern /> <ScrollToTop /> <Footer />   </>)
}
function Jv_arr()
{
  useDocumentTitle('Java Arrays')
  return (<>    <Heading /> <Jva_arr /> <ScrollToTop /> <Footer />   </>)
}
function Jv_arrRev()
{
  useDocumentTitle('Java Array Reverse')
  return (<>    <Heading /> <Jva_arrRev /> <ScrollToTop /> <Footer />   </>)
}
function Jv_ls()
{
  useDocumentTitle('Java Linear Search')
  return (<>    <Heading /> <Jva_Ls /> <ScrollToTop /> <Footer />   </>)
}
function Jv_mat()
{
  useDocumentTitle('Java matrix rotate clockwise')
  return (<>    <Heading /> <Jva_mat /> <ScrollToTop /> <Footer />   </>)
}
function Jv_bs()
{
  useDocumentTitle('Java Bubble sorting')
  return (<>    <Heading /> <Jva_bs /> <ScrollToTop /> <Footer />   </>)
}
function Jv_sel()
{
  useDocumentTitle('Java Selection sorting')
  return (<>    <Heading /> <Jva_sel /> <ScrollToTop /> <Footer />   </>)
}
function Jv_ref()
{
  useDocumentTitle('Java Refrences')
  return (<>    <Heading /> <Jva_ref /> <ScrollToTop /> <Footer />   </>)
}
function Jv_str()
{
  useDocumentTitle('Java String')
  return (<>    <Heading /> <Jva_str /> <ScrollToTop /> <Footer />   </>)
}
function Jv_sss()
{
  useDocumentTitle('String vs StringBuilder vs StringBuffer in Java')
  return (<>    <Heading /> <Jva_sss /> <ScrollToTop /> <Footer />   </>)
}
function Jv_strRev()
{
  useDocumentTitle('Reverse the string in Java')
  return (<>    <Heading /> <Jva_strRev /> <ScrollToTop /> <Footer />   </>)
}
function Jv_maxChar()
{
  useDocumentTitle('Java Program To Find Maximum And Minimum Occurring Character')
  return (<>    <Heading /> <Jva_maxChar /> <ScrollToTop /> <Footer />   </>)
}
function Jv_Dup()
{
  useDocumentTitle('Java Remove duplicates from a given string')
  return (<>    <Heading /> <Jva_Dup /> <ScrollToTop /> <Footer />   </>)
}
function Jv_tog()
{
  useDocumentTitle('Toggle the given string')
  return (<>    <Heading /> <Jva_tog /> <ScrollToTop /> <Footer />   </>)
}
function Jv_rec()
{
  useDocumentTitle('Recurssion in java')
  return (<>    <Heading /> <Jva_rec /> <ScrollToTop /> <Footer />   </>)
}
function Jv_pal()
{
  useDocumentTitle('Palindrome in java')
  return (<>    <Heading /> <Jva_pal /> <ScrollToTop /> <Footer />   </>)
}
function Jv_perm()
{
  useDocumentTitle('Find the permutation of given string')
  return (<>    <Heading /> <Jva_perm /> <ScrollToTop /> <Footer />   </>)
}
function Jv_rmz()
{
  useDocumentTitle('Rat in maze in java')
  return (<>    <Heading /> <Jva_rmz /> <ScrollToTop /> <Footer />   </>)
}
function Jv_nque()
{
  useDocumentTitle('N queen in java')
  return (<>    <Heading /> <Jva_nque /> <ScrollToTop /> <Footer />   </>)
}
function Jv_oops()
{
  useDocumentTitle('OOPS in java')
  return (<>    <Heading /> <Jva_oops /> <ScrollToTop /> <Footer />   </>)
}
function Jv_dma()
{
  useDocumentTitle('DMA- Dynamic memory allocation in java')
  return (<>    <Heading /> <Jva_dma /> <ScrollToTop /> <Footer />   </>)
}
function Jv_class()
{
  useDocumentTitle('Class and its member')
  return (<>    <Heading /> <Jva_class /> <ScrollToTop /> <Footer />   </>)
}
function Jv_method()
{
  useDocumentTitle('Difference between method overloading and method overriding in java')
  return (<>    <Heading /> <Jva_method /> <ScrollToTop /> <Footer />   </>)
}
function Jv_exce()
{
  useDocumentTitle('Exceptional handling in java')
  return (<>    <Heading /> <Jva_exce /> <ScrollToTop /> <Footer />   </>)
}
function Jv_abs()
{
  useDocumentTitle('Abstract list in java')
  return (<>    <Heading /> <Jva_abs /> <ScrollToTop /> <Footer />   </>)
}
function Jv_arrL()
{
  useDocumentTitle('Array list in java')
  return (<>    <Heading /> <Jva_arrL /> <ScrollToTop /> <Footer />   </>)
}
function Jv_ll()
{
  useDocumentTitle('Linked list in java')
  return (<>    <Heading /> <Jva_ll /> <ScrollToTop /> <Footer />   </>)
}
function Jv_posD()
{
  useDocumentTitle('delete an element from an array from a specified location')
  return (<>    <Heading /> <Jva_posD /> <ScrollToTop /> <Footer />   </>)
}
function Jv_int()
{
  useDocumentTitle('Find the intersection of two linked list in java ')
  return (<>    <Heading /> <Jva_int /> <ScrollToTop /> <Footer />   </>)
}
function Jv_del()
{
  useDocumentTitle('delete whole linked list')
  return (<>    <Heading /> <Jva_del /> <ScrollToTop /> <Footer />   </>)
}
function Jv_merge()
{
  useDocumentTitle('Merge two sorted linked list ')
  return (<>    <Heading /> <Jva_merge /> <ScrollToTop /> <Footer />   </>)
}
function Jv_stk()
{
  useDocumentTitle('stack in java ')
  return (<>    <Heading /> <Jva_stk /> <ScrollToTop /> <Footer />   </>)
}
function Jv_stkRev()
{
  useDocumentTitle('Reverse the stack in java ')
  return (<>    <Heading /> <Jva_stkRev /> <ScrollToTop /> <Footer />   </>)
}
function Jv_stIf()
{
  useDocumentTitle('Infix to postfix in java ')
  return (<>    <Heading /> <Jva_stIf /> <ScrollToTop /> <Footer />   </>)
}
function Jv_stock()
{
  useDocumentTitle('The stock span Problem in java ')
  return (<>    <Heading /> <Jva_stock /> <ScrollToTop /> <Footer />   </>)
}
function Jv_cleb()
{
  useDocumentTitle('The Celebrity Problem in java ')
  return (<>    <Heading /> <Jva_cleb /> <ScrollToTop /> <Footer />   </>)
}
function Jv_toh()
{
  useDocumentTitle('Tower of hanoi in java ')
  return (<>    <Heading /> <Jva_toh /> <ScrollToTop /> <Footer />   </>)
}
function Jv_sort()
{
  useDocumentTitle('Sort the stack in java ')
  return (<>    <Heading /> <Jva_sort /> <ScrollToTop /> <Footer />   </>)
}
function Jva_que()
{
  useDocumentTitle('Queue in java ')
  return (<>    <Heading /> <Jv_que /> <ScrollToTop /> <Footer />   </>)
}
function Jv_set()
{
  useDocumentTitle('Set in java ')
  return (<>    <Heading /> <Jva_set /> <ScrollToTop /> <Footer />   </>)
}

function Jv_mrg()
{
  useDocumentTitle('Merge Set in java ')
  return (<>    <Heading /> <Jva_set /> <ScrollToTop /> <Footer />   </>)
}
function Jv_vec()
{
  useDocumentTitle('Vector in java ')
  return (<>    <Heading /> <Jva_vec /> <ScrollToTop /> <Footer />   </>)
}
function Jv_map()
{
  useDocumentTitle('Map in java ')
  return (<>    <Heading /> <Jva_map /> <ScrollToTop /> <Footer />   </>)
}

function Pu()
{
  useDocumentTitle('Puzzels ')
  return (<>    <Heading /> <Puzz1 /> <ScrollToTop /> <Footer />   </>)
}
function Pu1()
{
  useDocumentTitle('measure forty-five minutes using two identical wires ')
  return (<>    <Heading /> <Puz1 />    </>)
}
function Pu2()
{
  useDocumentTitle('Find ages of daughters ')
  return (<>    <Heading /> <Puz2 /> <ScrollToTop /> <Footer />    </>)
}
function Puth()
{
  useDocumentTitle('Calculate total distance travelled by bee')
  return (<>    <Heading /> <Puzth />  <ScrollToTop /> <Footer />  </>)
}
function Pufo()
{
  useDocumentTitle('Pay an employee using a gold rod of 7 units ?')
  return (<>    <Heading /> <Puzfo />  <ScrollToTop /> <Footer />  </>)
}
function Pufi()
{
  useDocumentTitle('A King, 1000 Bottles of Wine, 10 Prisoners and a Drop of Poison')
  return (<>    <Heading /> <Puzfi />  <ScrollToTop /> <Footer />  </>)
}
function Pusi()
{
  useDocumentTitle('Monty Hall problem')
  return (<>    <Heading /> <Puzsi />  <ScrollToTop /> <Footer />  </>)
}
function Puse()
{
  useDocumentTitle('3 Bulbs and 3 Switches')
  return (<>    <Heading /> <Puzse />  <ScrollToTop /> <Footer />  </>)
}
function Pusei()
{
  useDocumentTitle('Find the Jar with contaminated pills')
  return (<>    <Heading /> <Puzei />  <ScrollToTop /> <Footer />  </>)
}
function Pusni()
{
  useDocumentTitle('Find the fastest 3 horses')
  return (<>    <Heading /> <Puzni />  <ScrollToTop /> <Footer />  </>)
}
function Puste()
{
  useDocumentTitle('A Man with Medical Condition and 2 Pills')
  return (<>    <Heading /> <Puzte />  <ScrollToTop /> <Footer />  </>)
}
function Pusel()
{
  useDocumentTitle('1000 Coins and 10 Bags')
  return (<>    <Heading /> <Puzel />  <ScrollToTop /> <Footer />  </>)
}
function Pu12()
{
  useDocumentTitle(' Maximize probability of White Ball')
  return (<>    <Heading /> <Puz12 />  <ScrollToTop /> <Footer />  </>)
}
function Pu13()
{
  useDocumentTitle('100 Prisoners with Red/Black Hats')
  return (<>    <Heading /> <Puz13 />  <ScrollToTop /> <Footer />  </>)
}
function Pu14()
{
  useDocumentTitle('Strategy for a 2 Player Coin Game')
  return (<>    <Heading /> <Puz14 />  <ScrollToTop /> <Footer />  </>)
}
function Pu15()
{
  useDocumentTitle('Camel and Banana Puzzle')
  return (<>    <Heading /> <Puz15 />  <ScrollToTop /> <Footer />  </>)
}
function Pu16()
{
  useDocumentTitle('100 Doors')
  return (<>    <Heading /> <Puz16 />  <ScrollToTop /> <Footer />  </>)
}
function Pu17()
{
  useDocumentTitle(' Ratio of Boys and Girls in a Country where people want only boys')
  return (<>    <Heading /> <Puz17 />  <ScrollToTop /> <Footer />  </>)
}
function Pu18()
{
  useDocumentTitle('Torch and Bridge')
  return (<>    <Heading /> <Puz18 />  <ScrollToTop /> <Footer />  </>)
}
function Pu19()
{
  useDocumentTitle('Poison and Rat')
  return (<>    <Heading /> <Puz19 />  <ScrollToTop /> <Footer />  </>)
}
function Pu20()
{
  useDocumentTitle(' 5 Pirates and 100 Gold Coins')
  return (<>    <Heading /> <Puz20 />  <ScrollToTop /> <Footer />  </>)
}
function Pu21()
{
  useDocumentTitle(' 3 Ants and Triangle')
  return (<>    <Heading /> <Puz21 />  <ScrollToTop /> <Footer />  </>)
}
function Pu22()
{
  useDocumentTitle('Maximum Chocolates')
  return (<>    <Heading /> <Puz22 />  <ScrollToTop /> <Footer />  </>)
}
function Pu23()
{
  useDocumentTitle('Days of month using 2 dice')
  return (<>    <Heading /> <Puz23 />  <ScrollToTop /> <Footer />  </>)
}
function Pu24()
{
  useDocumentTitle(' 10 Coins  ')
  return (<>    <Heading /> <Puz24 />  <ScrollToTop /> <Footer />  </>)
}
function Pu25()
{
  useDocumentTitle('Chessboard and dominos   ')
  return (<>    <Heading /> <Puz25 />  <ScrollToTop /> <Footer />  </>)
}
function Pu26()
{
  useDocumentTitle('Know Average Salary without Disclosing Individual Salaries')
  return (<>    <Heading /> <Puz26 />  <ScrollToTop /> <Footer />  </>)
}
function Pu27()
{
  useDocumentTitle('Hourglasses  ')
  return (<>    <Heading /> <Puz27 />  <ScrollToTop /> <Footer />  </>)
}
function Pu28()
{
  useDocumentTitle('Newspaper Puzzle ')
  return (<>    <Heading /> <Puz28 />  <ScrollToTop /> <Footer />  </>)
}
function Pu29()
{
  useDocumentTitle('Car Wheel Puzzle')
  return (<>    <Heading /> <Puz29 />  <ScrollToTop /> <Footer />  </>)
}
function Pu30()
{
  useDocumentTitle('Last Palindrome Date Before 10/02/2001')
  return (<>    <Heading /> <Puz30 />  <ScrollToTop /> <Footer />  </>)
}
function Pu31()
{
  useDocumentTitle('Minimum Cut Puzzel  ')
  return (<>    <Heading /> <Puz31 />  <ScrollToTop /> <Footer />  </>)
}
function Pu32()
{
  useDocumentTitle('Completion of Task ')
  return (<>    <Heading /> <Puz32 />  <ScrollToTop /> <Footer />  </>)
}
function Pu33()
{
  useDocumentTitle('Rs 500 Note Puzzle ')
  return (<>    <Heading /> <Puz33 />  <ScrollToTop /> <Footer />  </>)
}
function Pu34()
{
  useDocumentTitle('Prisoner and Policeman Puzzle ')
  return (<>    <Heading /> <Puz34 />  <ScrollToTop /> <Footer />  </>)
}
function Pu35()
{
  useDocumentTitle('2 Eggs and 100 Floors ')
  return (<>    <Heading /> <Puz35 />  <ScrollToTop /> <Footer />  </>)
}
function Pu36()
{
  useDocumentTitle('Matchstick Puzzle ')
  return (<>    <Heading /> <Puz36 />  <ScrollToTop /> <Footer />  </>)
}
function Pu37()
{
  useDocumentTitle('Maximum run in cricket ')
  return (<>    <Heading /> <Puz37 />  <ScrollToTop /> <Footer />  </>)
}
function Pu38()
{
  useDocumentTitle(' Tic Tac Toe ')
  return (<>    <Heading /> <Puz38 />  <ScrollToTop /> <Footer />  </>)
}
function Pu39()
{
  useDocumentTitle('100 coin')
  return (<>    <Heading /> <Puz39 />  <ScrollToTop /> <Footer />  </>)
}
function Pu40()
{
  useDocumentTitle('Find missing Row in Excel ')
  return (<>    <Heading /> <Puz40 />  <ScrollToTop /> <Footer />  </>)
}
function Pu41()
{
  useDocumentTitle(' Guess Color of Hat ')
  return (<>    <Heading /> <Puz41 />  <ScrollToTop /> <Footer />  </>)
}
function Pu42()
{
  useDocumentTitle(' Placing the numbers')
  return (<>    <Heading /> <Puz42 />  <ScrollToTop /> <Footer />  </>)
}
function Pu43()
{
  useDocumentTitle('Muddy Head ')
  return (<>    <Heading /> <Puz43 />  <ScrollToTop /> <Footer />  </>)
}
function Pu44()
{
  useDocumentTitle('Girl or Boy ')
  return (<>    <Heading /> <Puz44 />  <ScrollToTop /> <Footer />  </>)
}
function Pu45()
{
  useDocumentTitle(' Find the culprit')
  return (<>    <Heading /> <Puz45 />  <ScrollToTop /> <Footer />  </>)
}



function IntQ()
{
  useDocumentTitle(' Interview question')
  return (<>    <Heading /> <Iq />  <ScrollToTop /> <Footer />  </>)
}
function Some()
{
  useDocumentTitle(' Aptitude question: Average ')
  return (<>    <Heading /> <Somes />  <ScrollToTop /> <Footer />  </>)
}
function Iqs2()
{
  useDocumentTitle('Aptitude question: Compund Intrest ')
  return (<>    <Heading /> <Iq2 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs3()
{
  useDocumentTitle('Aptitude question: Patnership Problem ')
  return (<>    <Heading /> <Iq3 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs4()
{
  useDocumentTitle('Aptitude question: Calender ')
  return (<>    <Heading /> <Iq4 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs5()
{
  useDocumentTitle('Aptitude question: Time and work ')
  return (<>    <Heading /> <Iq5 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs6()
{
  useDocumentTitle('Aptitude question: HCF and LCM ')
  return (<>    <Heading /> <Iq6 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs7()
{
  useDocumentTitle('Aptitude question: Volume Surface and Area ')
  return (<>    <Heading /> <Iq7 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs8()
{
  useDocumentTitle('Aptitude question: Odd man out series')
  return (<>    <Heading /> <Iq8 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs9()
{
  useDocumentTitle('Aptitude question: Stocks And Shares')
  return (<>    <Heading /> <Iq9 />  <ScrollToTop /> <Footer />  </>)
}

function Iqs10()
{
  useDocumentTitle('Aptitude question: Permutation And Combination ')
  return (<>    <Heading /> <Iq10 />  <ScrollToTop /> <Footer />  </>)
}



function Brs1()
{
  useDocumentTitle('Blood Relation ')
  return (<>    <Heading /> <Br1 />  <ScrollToTop /> <Footer />  </>)
}


function Ord()
{
  useDocumentTitle('Make in Order')
  return (<>    <Heading /> <Order />  <ScrollToTop /> <Footer />  </>)
}



function Amz()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amazn />  <ScrollToTop /> <Footer />  </>)
}
function Goo()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle />  <ScrollToTop /> <Footer />  </>)
}
function Micro()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft />  <ScrollToTop /> <Footer />  </>)
}

function Snd()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snapdeal />  <ScrollToTop /> <Footer />  </>)
}
function Qlc()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qualcomm />  <ScrollToTop /> <Footer />  </>)
}
function Smsun()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Samsung />  <ScrollToTop /> <Footer />  </>)
}
function Flpk()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt />  <ScrollToTop /> <Footer />  </>)
}
function Makemy()
{
  useDocumentTitle('MakeMyTrip Interview Question ')
  return (<>    <Heading /> <Mmt />  <ScrollToTop /> <Footer />  </>)
}
function Goldman()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gs />  <ScrollToTop /> <Footer />  </>)
}
function Acco()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc />  <ScrollToTop /> <Footer />  </>)
}
function Yah()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho />  <ScrollToTop /> <Footer />  </>)
}
function De()
{
  useDocumentTitle('DE-shaw Interview Question ')
  return (<>    <Heading /> <Dshaw />  <ScrollToTop /> <Footer />  </>)
}
function Pytm()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Paytm />  <ScrollToTop /> <Footer />  </>)
}
function Ol()
{
  useDocumentTitle('Ola Interview Question ')
  return (<>    <Heading /> <Ola />  <ScrollToTop /> <Footer />  </>)
}
function Cis()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cisco />  <ScrollToTop /> <Footer />  </>)
}



function Am1()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz1 />  <ScrollToTop /> <Footer />  </>)
}
function Am2()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz2 />  <ScrollToTop /> <Footer />  </>)
}
function Am3()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz3 />  <ScrollToTop /> <Footer />  </>)
}
function Am4()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz4 />  <ScrollToTop /> <Footer />  </>)
}
function Am5()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz5 />  <ScrollToTop /> <Footer />  </>)
}
function Am6()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz6 />  <ScrollToTop /> <Footer />  </>)
}
function Am7()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz1 />  <ScrollToTop /> <Footer />  </>)
}
function Am8()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz8 />  <ScrollToTop /> <Footer />  </>)
}
function Am9()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz9 />  <ScrollToTop /> <Footer />  </>)
}
function Am10()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz10 />  <ScrollToTop /> <Footer />  </>)
}
function Am11()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz11 />  <ScrollToTop /> <Footer />  </>)
}
function Am12()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz12 />  <ScrollToTop /> <Footer />  </>)
}
function Am13()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz13 />  <ScrollToTop /> <Footer />  </>)
}
function Am14()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz14 />  <ScrollToTop /> <Footer />  </>)
}
function Am15()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz15 />  <ScrollToTop /> <Footer />  </>)
}
function Am16()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz16 />  <ScrollToTop /> <Footer />  </>)
}
function Am17()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz17 />  <ScrollToTop /> <Footer />  </>)
}
function Am18()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz18 />  <ScrollToTop /> <Footer />  </>)
}
function Am19()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz19 />  <ScrollToTop /> <Footer />  </>)
}
function Am20()
{
  useDocumentTitle('Amazon Interview Question ')
  return (<>    <Heading /> <Amz20 />  <ScrollToTop /> <Footer />  </>)
}


function Gg1()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle1 />  <ScrollToTop /> <Footer />  </>)
}
function Gg2()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle2 />  <ScrollToTop /> <Footer />  </>)
}
function Gg3()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle3 />  <ScrollToTop /> <Footer />  </>)
}
function Gg4()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle4 />  <ScrollToTop /> <Footer />  </>)
}

function Gg5()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle5 />  <ScrollToTop /> <Footer />  </>)
}
function Gg6()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle6 />  <ScrollToTop /> <Footer />  </>)
}
function Gg7()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle7 />  <ScrollToTop /> <Footer />  </>)
}
function Gg8()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle8 />  <ScrollToTop /> <Footer />  </>)
}
function Gg9()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle9 />  <ScrollToTop /> <Footer />  </>)
}
function Gg10()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle10 />  <ScrollToTop /> <Footer />  </>)
}
function Gg11()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle11 />  <ScrollToTop /> <Footer />  </>)
}
function Gg12()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle12 />  <ScrollToTop /> <Footer />  </>)
}
function Gg13()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle13 />  <ScrollToTop /> <Footer />  </>)
}
function Gg14()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle14 />  <ScrollToTop /> <Footer />  </>)
}
function Gg15()
{
  useDocumentTitle('Google Interview Question ')
  return (<>    <Heading /> <Ggle15 />  <ScrollToTop /> <Footer />  </>)
}


function Ms2()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft2 />  <ScrollToTop /> <Footer />  </>)
}
function Ms3()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft3 />  <ScrollToTop /> <Footer />  </>)
}
function Ms4()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft4 />  <ScrollToTop /> <Footer />  </>)
}
function Ms5()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft5 />  <ScrollToTop /> <Footer />  </>)
}
function Ms6()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft6 />  <ScrollToTop /> <Footer />  </>)
}
function Ms7()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft7 />  <ScrollToTop /> <Footer />  </>)
}
function Ms8()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft8 />  <ScrollToTop /> <Footer />  </>)
}
function Ms9()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft9 />  <ScrollToTop /> <Footer />  </>)
}
function Ms10()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft10 />  <ScrollToTop /> <Footer />  </>)
}
function Ms11()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft11 />  <ScrollToTop /> <Footer />  </>)
}
function Ms12()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft12 />  <ScrollToTop /> <Footer />  </>)
}
function Ms13()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft13 />  <ScrollToTop /> <Footer />  </>)
}
function Ms14()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft14 />  <ScrollToTop /> <Footer />  </>)
}
function Ms15()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft15 />  <ScrollToTop /> <Footer />  </>)
}
function Ms16()
{
  useDocumentTitle('Microsoft Interview Question ')
  return (<>    <Heading /> <Mcrsft16 />  <ScrollToTop /> <Footer />  </>)
}


function Ds1()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw1 />  <ScrollToTop /> <Footer />  </>)
}
function Ds2()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw2 />  <ScrollToTop /> <Footer />  </>)
}
function Ds3()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw3 />  <ScrollToTop /> <Footer />  </>)
}
function Ds4()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw4 />  <ScrollToTop /> <Footer />  </>)
}
function Ds5()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw5 />  <ScrollToTop /> <Footer />  </>)
}
function Ds6()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw6 />  <ScrollToTop /> <Footer />  </>)
}
function Ds7()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw7 />  <ScrollToTop /> <Footer />  </>)
}
function Ds8()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw8 />  <ScrollToTop /> <Footer />  </>)
}
function Ds9()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw9 />  <ScrollToTop /> <Footer />  </>)
}
function Ds10()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw10 />  <ScrollToTop /> <Footer />  </>)
}
function Ds11()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw11 />  <ScrollToTop /> <Footer />  </>)
}
function Ds12()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw12 />  <ScrollToTop /> <Footer />  </>)
}
function Ds13()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw13 />  <ScrollToTop /> <Footer />  </>)
}
function Ds14()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw14 />  <ScrollToTop /> <Footer />  </>)
}
function Ds15()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw15 />  <ScrollToTop /> <Footer />  </>)
}
function Ds16()
{
  useDocumentTitle('DE Shaw Interview Question ')
  return (<>    <Heading /> <Dsw16 />  <ScrollToTop /> <Footer />  </>)
}


function Ac1()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc1 />  <ScrollToTop /> <Footer />  </>)
}
function Ac2()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc2 />  <ScrollToTop /> <Footer />  </>)
}
function Ac3()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc3 />  <ScrollToTop /> <Footer />  </>)
}
function Ac4()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc4 />  <ScrollToTop /> <Footer />  </>)
}
function Ac5()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc5 />  <ScrollToTop /> <Footer />  </>)
}
function Ac6()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc6 />  <ScrollToTop /> <Footer />  </>)
}
function Ac7()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc7 />  <ScrollToTop /> <Footer />  </>)
}
function Ac8()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc8 />  <ScrollToTop /> <Footer />  </>)
}
function Ac9()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc9 />  <ScrollToTop /> <Footer />  </>)
}
function Ac10()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc10 />  <ScrollToTop /> <Footer />  </>)
}
function Ac11()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc11 />  <ScrollToTop /> <Footer />  </>)
}
function Ac12()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc12 />  <ScrollToTop /> <Footer />  </>)
}
function Ac13()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc13 />  <ScrollToTop /> <Footer />  </>)
}
function Ac14()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc14 />  <ScrollToTop /> <Footer />  </>)
}
function Ac15()
{
  useDocumentTitle('Accolite Interview Question ')
  return (<>    <Heading /> <Acc15 />  <ScrollToTop /> <Footer />  </>)
}

function Yah1()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho1 />  <ScrollToTop /> <Footer />  </>)
}
function Yah2()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho2 />  <ScrollToTop /> <Footer />  </>)
}
function Yah3()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho3 />  <ScrollToTop /> <Footer />  </>)
}
function Yah4()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho4 />  <ScrollToTop /> <Footer />  </>)
}
function Yah5()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho5 />  <ScrollToTop /> <Footer />  </>)
}
function Yah6()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho6 />  <ScrollToTop /> <Footer />  </>)
}
function Yah7()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho7 />  <ScrollToTop /> <Footer />  </>)
}
function Yah8()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho8 />  <ScrollToTop /> <Footer />  </>)
}
function Yah9()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho9 />  <ScrollToTop /> <Footer />  </>)
}
function Yah10()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho10 />  <ScrollToTop /> <Footer />  </>)
}
function Yah11()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho11 />  <ScrollToTop /> <Footer />  </>)
}
function Yah12()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho12 />  <ScrollToTop /> <Footer />  </>)
}
function Yah13()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho13 />  <ScrollToTop /> <Footer />  </>)
}
function Yah14()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho14 />  <ScrollToTop /> <Footer />  </>)
}
function Yah15()
{
  useDocumentTitle('Yahoo Interview Question ')
  return (<>    <Heading /> <Yho15 />  <ScrollToTop /> <Footer />  </>)
}



function Gs1()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld1 />  <ScrollToTop /> <Footer />  </>)
}
function Gs2()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld2 />  <ScrollToTop /> <Footer />  </>)
}
function Gs3()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld3 />  <ScrollToTop /> <Footer />  </>)
}
function Gs4()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld4 />  <ScrollToTop /> <Footer />  </>)
}
function Gs5()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld5 />  <ScrollToTop /> <Footer />  </>)
}
function Gs6()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld6 />  <ScrollToTop /> <Footer />  </>)
}
function Gs7()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld7 />  <ScrollToTop /> <Footer />  </>)
}
function Gs8()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld8 />  <ScrollToTop /> <Footer />  </>)
}
function Gs9()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld9 />  <ScrollToTop /> <Footer />  </>)
}
function Gs10()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld10 />  <ScrollToTop /> <Footer />  </>)
}
function Gs11()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld11 />  <ScrollToTop /> <Footer />  </>)
}
function Gs12()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld12 />  <ScrollToTop /> <Footer />  </>)
}
function Gs13()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld13 />  <ScrollToTop /> <Footer />  </>)
}
function Gs14()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld14 />  <ScrollToTop /> <Footer />  </>)
}
function Gs15()
{
  useDocumentTitle('Goldman Sachs Interview Question ')
  return (<>    <Heading /> <Gld15 />  <ScrollToTop /> <Footer />  </>)
}


function Mmt1()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt1 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt2()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt2 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt3()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt3 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt4()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt4 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt5()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt5 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt6()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt6 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt7()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt7 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt8()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt8 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt9()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt9 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt10()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt10 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt11()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt11 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt12()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt12 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt13()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt13 />  <ScrollToTop /> <Footer />  </>)
}
function Mmt14()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt14 />  <ScrollToTop /> <Footer />  </>)
}

function Mmt15()
{
  useDocumentTitle('Make My Trip Interview Question ')
  return (<>    <Heading /> <Mt15 />  <ScrollToTop /> <Footer />  </>)
}


function Flp1()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt1 />  <ScrollToTop /> <Footer />  </>)
}
function Flp2()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt2 />  <ScrollToTop /> <Footer />  </>)
}
function Flp3()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt3 />  <ScrollToTop /> <Footer />  </>)
}
function Flp4()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt4 />  <ScrollToTop /> <Footer />  </>)
}
function Flp5()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt5 />  <ScrollToTop /> <Footer />  </>)
}
function Flp6()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt6 />  <ScrollToTop /> <Footer />  </>)
}
function Flp7()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt7 />  <ScrollToTop /> <Footer />  </>)
}
function Flp8()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt8 />  <ScrollToTop /> <Footer />  </>)
}
function Flp9()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt9 />  <ScrollToTop /> <Footer />  </>)
}
function Flp10()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt10 />  <ScrollToTop /> <Footer />  </>)
}
function Flp11()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt11 />  <ScrollToTop /> <Footer />  </>)
}
function Flp12()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt12 />  <ScrollToTop /> <Footer />  </>)
}
function Flp13()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt13 />  <ScrollToTop /> <Footer />  </>)
}
function Flp14()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt14 />  <ScrollToTop /> <Footer />  </>)
}
function Flp15()
{
  useDocumentTitle('Flipkart Interview Question ')
  return (<>    <Heading /> <Flpkrt15 />  <ScrollToTop /> <Footer />  </>)
}



function Ptm1()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm1 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm2()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm2 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm3()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm3 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm4()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm4 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm5()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm5 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm6()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm6 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm7()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm7 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm8()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm8 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm9()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm9 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm10()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm10 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm11()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm11 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm12()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm12 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm13()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm13 />  <ScrollToTop /> <Footer />  </>)
}
function Ptm14()
{
  useDocumentTitle('Paytm Interview Question ')
  return (<>    <Heading /> <Pytm14 />  <ScrollToTop /> <Footer />  </>)
}


function Ol1()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola1 />  <ScrollToTop /> <Footer />  </>)
}
function Ol2()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola2 />  <ScrollToTop /> <Footer />  </>)
}
function Ol3()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola3 />  <ScrollToTop /> <Footer />  </>)
}
function Ol4()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola4 />  <ScrollToTop /> <Footer />  </>)
}
function Ol5()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola5 />  <ScrollToTop /> <Footer />  </>)
}
function Ol6()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola6 />  <ScrollToTop /> <Footer />  </>)
}
function Ol7()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola7 />  <ScrollToTop /> <Footer />  </>)
}
function Ol8()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola8 />  <ScrollToTop /> <Footer />  </>)
}
function Ol9()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola9 />  <ScrollToTop /> <Footer />  </>)
}
function Ol10()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola10 />  <ScrollToTop /> <Footer />  </>)
}
function Ol11()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola11 />  <ScrollToTop /> <Footer />  </>)
}
function Ol12()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola12 />  <ScrollToTop /> <Footer />  </>)
}
function Ol13()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola13 />  <ScrollToTop /> <Footer />  </>)
}
function Ol14()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola14 />  <ScrollToTop /> <Footer />  </>)
}
function Ol15()
{
  useDocumentTitle('Ola Cabs Interview Question ')
  return (<>    <Heading /> <Ola15 />  <ScrollToTop /> <Footer />  </>)
}



function Cisc1()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis1 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc2()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis2 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc3()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis3 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc4()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis4 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc5()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis5 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc6()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis6 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc7()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis7 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc8()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis8 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc9()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis9 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc10()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis10 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc11()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis11 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc12()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis12 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc13()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis13 />  <ScrollToTop /> <Footer />  </>)
}
function Cisc14()
{
  useDocumentTitle('Cisco Interview Question ')
  return (<>    <Heading /> <Cis14 />  <ScrollToTop /> <Footer />  </>)
}


function Smsu1()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung1 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu2()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung2 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu3()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung3 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu4()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung4 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu5()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung5 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu6()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung6 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu7()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung7 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu8()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung8 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu9()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung9 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu10()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung10 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu11()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung11 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu12()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung12 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu13()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung13 />  <ScrollToTop /> <Footer />  </>)
}
function Smsu14()
{
  useDocumentTitle('Samsung Interview Question ')
  return (<>    <Heading /> <Smsung14 />  <ScrollToTop /> <Footer />  </>)
}



function Qualc1()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual1 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc2()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual2 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc3()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual3 />  <ScrollToTop /> <Footer />  </>)
}

function Qualc4()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual4 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc5()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual5 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc6()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual6 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc7()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual7 />  <ScrollToTop /> <Footer />  </>)
}

function Qualc8()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual8 />  <ScrollToTop /> <Footer />  </>)
}

function Qualc9()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual9 />  <ScrollToTop /> <Footer />  </>)
}

function Qualc11()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual11 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc12()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual12 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc13()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual13 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc14()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual14 />  <ScrollToTop /> <Footer />  </>)
}
function Qualc15()
{
  useDocumentTitle('Qualcomm Interview Question ')
  return (<>    <Heading /> <Qual15 />  <ScrollToTop /> <Footer />  </>)
}




function Snpd1()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp1 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd2()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp2 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd3()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp3 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd4()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp4 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd5()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp5 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd6()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp6 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd7()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp7 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd8()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp8 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd9()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp9 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd10()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp10 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd11()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp11 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd12()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp12 />  <ScrollToTop /> <Footer />  </>)
}
function Snpd13()
{
  useDocumentTitle('Snapdeal Interview Question ')
  return (<>    <Heading /> <Snp13 />  <ScrollToTop /> <Footer />  </>)
}


function RdMp()
{
  useDocumentTitle('Career Options ')
  return (<>    <Heading /> <Radmap_design />  <ScrollToTop /> <Footer />  </>)
}
function SftDv()
{
  useDocumentTitle('Software developer Roadmap ')
  return (<>    <Heading /> <Software_dev />  <ScrollToTop /> <Footer />  </>)
}
function DBa()
{
  useDocumentTitle('Database Administrator Roadmap ')
  return (<>    <Heading /> <Dba />  <ScrollToTop /> <Footer />  </>)
}
function CHe()
{
  useDocumentTitle('Database Administrator Roadmap ')
  return (<>    <Heading />  <Che />  <ScrollToTop /> <Footer />  </>)
}
function CSa()
{
  useDocumentTitle('Database Administrator Roadmap ')
  return (<>    <Heading />   <Da /> <ScrollToTop /> <Footer />  </>)
}
function CNa()
{
  useDocumentTitle('Database Administrator Roadmap ')
  return (<>    <Heading />    <Cna /> <ScrollToTop /> <Footer />  </>)
}
function Wd()
{
  useDocumentTitle('Web Development Roadmap ')
  return (<>    <Heading />    <Web_dev />  <ScrollToTop /> <Footer />  </>)
}
function Pm()
{
  useDocumentTitle('Project Manager Roadmap ')
  return (<>    <Heading />    <Project_man />  <ScrollToTop /> <Footer />  </>)
}
function Blg()
{
  useDocumentTitle('Project Manager Roadmap ')
  return (<>    <Heading />    <Blog />  <ScrollToTop /> <Footer />  </>)
}
function Cd()
{
  useDocumentTitle('Content Developer Roadmap ')
  return (<>    <Heading />    <Content_dev />   <ScrollToTop /> <Footer />  </>)
}
function Auth()
{
  useDocumentTitle('Author For Programming Books Roadmap ')
  return (<>    <Heading />    <Author />   <ScrollToTop /> <Footer />  </>)
}
function Onli()
{
  useDocumentTitle('Online Marketing Roadmap ')
  return (<>    <Heading />    <Online />   <ScrollToTop /> <Footer />  </>)
}
function WebD()
{
  useDocumentTitle('Web Designer Roadmap ')
  return (<>    <Heading />    <Web_designer />   <ScrollToTop /> <Footer />  </>)
}
function Strt()
{
  useDocumentTitle('Startup Roadmap ')
  return (<>    <Heading />    <Startup />   <ScrollToTop /> <Footer />  </>)
}
function Sam()
{
  useDocumentTitle('Sales and Marketing Roadmap ')
  return (<>    <Heading />    <Marketing />   <ScrollToTop /> <Footer />  </>)
}
function Pro()
{
  useDocumentTitle('Professors of programming language Roadmap ')
  return (<>    <Heading />    <Prof />   <ScrollToTop /> <Footer />  </>)
}
function Pcb()
{
  useDocumentTitle('PCB Designer Roadmap ')
  return (<>    <Heading />     <PCB /> <ScrollToTop />  <Footer /> </>)
}
function Fronte()
{
  useDocumentTitle('Front End Developer ')
  return (<>    <Heading />     <Front /> <ScrollToTop />  <Footer /> </>)
}
function Backe()
{
  useDocumentTitle('Back End Developer ')
  return (<>    <Heading />     <Backend /> <ScrollToTop />  <Footer /> </>)
}
function AI()
{
  useDocumentTitle('Artifical Intelligence ')
  return (<>    <Heading />     <Ai /> <ScrollToTop />  <Footer /> </>)
}
function Fds()
{
  useDocumentTitle('Full stack development ')
  return (<>    <Heading />     <FullStk /> <ScrollToTop />  <Footer /> </>)
}
function Dscien()
{
  useDocumentTitle('Data Scientist  ')
  return (<>    <Heading />     <DataSci /> <ScrollToTop />  <Footer /> </>)
}
function DAnal()
{
  useDocumentTitle('Data Analyst ')
  return (<>    <Heading />     <DataAnal /> <ScrollToTop />  <Footer /> </>)
}
function Androi()
{
  useDocumentTitle('Android Developer')
  return (<>    <Heading />     <Android /> <ScrollToTop />  <Footer /> </>)
}
function Block()
{
  useDocumentTitle('Blockhain Development')
  return (<>    <Heading />     <Blockchain /> <ScrollToTop />  <Footer /> </>)
}
function Neto()
{
  useDocumentTitle('Computer Network Architect')
  return (<>    <Heading />     <Network /> <ScrollToTop />  <Footer /> </>)
}
function Admins()
{
  useDocumentTitle('Database Administrator')
  return (<>    <Heading />     <Admin /> <ScrollToTop />  <Footer /> </>)
}



// function DataIndex()
// {
//   useDocumentTitle('Data Structure')
//   return (<>    <Heading />     <Index /> <ScrollToTop />  <Footer /> </>)
// }

// function ArrD()
// {
//   useDocumentTitle('Array Data Structure')
//   return (<>    <Heading />     <ArrayD /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayInt()
// {
//   useDocumentTitle('Array Introduction- Data Structure')
//   return (<>    <Heading />     <ArrayIntro /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayIntD()
// {
//   useDocumentTitle('Array Introduction')
//   return (<>    <Heading />     <ArrayIntroD /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayDC()
// {
//   useDocumentTitle('Array In C++')
//   return (<>    <Heading />     <ArrDC /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayDJ()
// {
//   useDocumentTitle('Array In Java')
//   return (<>    <Heading />     <ArrDJ /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayDP()
// {
//   useDocumentTitle('Array In Python')
//   return (<>    <Heading />     <ArrDP /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRotInd()
// {
//   useDocumentTitle('Array Rotation')
//   return (<>    <Heading />     <ArrRotInd /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot1()
// {
//   useDocumentTitle('Program for array rotation')
//   return (<>    <Heading />     <ArrRot1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot2()
// {
//   useDocumentTitle('Reversal algorithm for array rotation')
//   return (<>    <Heading />     <ArrRot2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot3()
// {
//   useDocumentTitle('Block swap algorithm for array rotation')
//   return (<>    <Heading />     <ArrRot3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot4()
// {
//   useDocumentTitle('Program to cyclically rotate an array by one')
//   return (<>    <Heading />     <ArrRot4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot5()
// {
//   useDocumentTitle('Search an element in a sorted and rotated array')
//   return (<>    <Heading />     <ArrRot5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot6()
// {
//   useDocumentTitle('Given a sorted and rotated array, find if there is a pair with a given sum')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot7()
// {
//   useDocumentTitle('Find maximum value of Sum( i*arr[i]) with only rotations on given array allowed')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot8()
// {
//   useDocumentTitle('Maximum sum of i*arr[i] among all rotations of a given array')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot9()
// {
//   useDocumentTitle('Find the Rotation Count in Rotated Sorted array')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot10()
// {
//   useDocumentTitle('Quickly find multiple left rotations of an array ')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot11()
// {
//   useDocumentTitle('Find the minimum element in a sorted and rotated array')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot12()
// {
//   useDocumentTitle('Reversal algorithm for right rotation of an array')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot13()
// {
//   useDocumentTitle('Split the array and add the first part to the end')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot14()
// {
//   useDocumentTitle('Find a rotation with maximum hamming distance')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot15()
// {
//   useDocumentTitle('Queries on Left and Right Circular shift on array')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot16()
// {
//   useDocumentTitle('Print left rotation of array in O(n) time and O(1) space')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArrayRot17()
// {
//   useDocumentTitle('Find element at given index after a number of rotations')
//   return (<>    <Heading />     <ArrRot6 /> <ScrollToTop />  <Footer /> </>)

// }
// function RearrangInd()
// {
//   useDocumentTitle('Arrangement Rearrangement')
//   return (<>    <Heading />     <RearrInd /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang1()
// {
//   useDocumentTitle('Write a program to reverse an array or string')
//   return (<>    <Heading />     <Rearr1 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang2()
// {
//   useDocumentTitle('Rearrange positive and negative numbers in O(n) time and O(1) extra space')
//   return (<>    <Heading />     <Rearr2 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang3()
// {
//   useDocumentTitle('Move all zeroes to end of array')
//   return (<>    <Heading />     <Rearr3 /> <ScrollToTop />  <Footer /> </>)

// }

// function Rearrang4()
// {
//   useDocumentTitle('Minimum swaps required to bring all elements less than or equal to k together')
//   return (<>    <Heading />     <Rearr4 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang5()
// {
//   useDocumentTitle('Rearrange array such that even positioned are greater than odd')
//   return (<>    <Heading />     <Rearr5 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang6()
// {
//   useDocumentTitle('Double the first element and move zero to end')
//   return (<>    <Heading />     <Rearr6 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang7()
// {
//   useDocumentTitle('Rearrange positive and negative numbers with constant extra space')
//   return (<>    <Heading />     <Rearr7 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang8()
// {
//   useDocumentTitle('Rearrange an array such that ‘arr[j]’ becomes ‘i’ if ‘arr[i]’ is ‘j’')
//   return (<>    <Heading />     <Rearr8 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang9()
// {
//   useDocumentTitle('Rearrange an array in maximum minimum form ')
//   return (<>    <Heading />     <Rearr9 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang10()
// {
//   useDocumentTitle('Move all negative elements to end in order with extra space allowed')
//   return (<>    <Heading />     <Rearr10 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang11()
// {
//   useDocumentTitle('Rearrange array such that even index elements are smaller and odd index elements are greate')
//   return (<>    <Heading />     <Rearr11 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang12()
// {
//   useDocumentTitle('Positive elements at even and negative at odd positions')
//   return (<>    <Heading />     <Rearr12 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang13()
// {
//   useDocumentTitle('Replace every array element by multiplication of previous and next')
//   return (<>    <Heading />     <Rearr13 /> <ScrollToTop />  <Footer /> </>)

// }
// function Rearrang14()
// {
//   useDocumentTitle('Shuffle a given array')
//   return (<>    <Heading />     <Rearr14 /> <ScrollToTop />  <Footer /> </>)

// }


// function ArOS()
// {
//   useDocumentTitle('Order Statistic')
//   return (<>    <Heading />     <ArrOSind /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS1()
// {
//   useDocumentTitle('K’th Smallest/Largest Element in Unsorted Array')
//   return (<>    <Heading />     <ArrOS1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS2()
// {
//   useDocumentTitle('k largest(or smallest) elements in an array | added Min Heap method')
//   return (<>    <Heading />     <ArrOS2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS3()
// {
//   useDocumentTitle('Program to find largest element in an array')
//   return (<>    <Heading />     <ArrOS3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS4()
// {
//   useDocumentTitle('Find the largest three elements in an array')
//   return (<>    <Heading />     <ArrOS4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS5()
// {
//   useDocumentTitle('Program for Mean and median of an unsorted arrayc')
//   return (<>    <Heading />     <ArrOS5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS6()
// {
//   useDocumentTitle('Minimum product of k integers in an array of positive Integers')
//   return (<>    <Heading />     <ArrOS6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS7()
// {
//   useDocumentTitle('K maximum sum combinations from two arrays')
//   return (<>    <Heading />     <ArrOS7 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS8()
// {
//   useDocumentTitle('k smallest elements in same order using O(1) extra space')
//   return (<>    <Heading />     <ArrOS8 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS9()
// {
//   useDocumentTitle('k-th smallest absolute difference of two elements in an array')
//   return (<>    <Heading />     <ArrOS9 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS10()
// {
//   useDocumentTitle('Find the smallest and second smallest elements in an array')
//   return (<>    <Heading />     <ArrOS10 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS11()
// {
//   useDocumentTitle('Maximum sum such that no two elements are adjacent')
//   return (<>    <Heading />     <ArrOS11 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS12()
// {
//   useDocumentTitle('Maximum and minimum of an array using minimum number of comparisons')
//   return (<>    <Heading />     <ArrOS12 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOS13()
// {
//   useDocumentTitle('Median of Stream of Running Integers using STL')
//   return (<>    <Heading />     <ArrOS13 /> <ScrollToTop />  <Footer /> </>)

// }




// function ArRq()
// {
//   useDocumentTitle('Range Queries')
//   return (<>    <Heading />     <ArrRqInd /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq1()
// {
//   useDocumentTitle('MO’s Algorithm')
//   return (<>    <Heading />     <ArrRq1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq2()
// {
//   useDocumentTitle('Range sum query using Sparse Table')
//   return (<>    <Heading />     <ArrRq2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq3()
// {
//   useDocumentTitle('Range Queries for Frequencies of array elements')
//   return (<>    <Heading />     <ArrRq3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq4()
// {
//   useDocumentTitle('Range LCM Queries')
//   return (<>    <Heading />     <ArrRq4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq5()
// {
//   useDocumentTitle('Queries for GCD of all numbers of an array except elements in a given range')
//   return (<>    <Heading />     <ArrRq5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq6()
// {
//   useDocumentTitle('Number of elements less than or equal to a given number in a given subarray (Including Updates)')
//   return (<>    <Heading />     <ArrRq6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq7()
// {
//   useDocumentTitle('Queries for decimal values of subarrays of a binary array')
//   return (<>    <Heading />     <ArrRq7 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq8()
// {
//   useDocumentTitle('Number whose sum of XOR with given array range is maximum')
//   return (<>    <Heading />     <ArrRq8 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq9()
// {
//   useDocumentTitle('Array range queries over range queries')
//   return (<>    <Heading />     <ArrRq9 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq10()
// {
//   useDocumentTitle('Array range queries for elements with frequency same as value')
//   return (<>    <Heading />     <ArrRq10 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq11()
// {
//   useDocumentTitle('Number of indexes with equal elements in given range')
//   return (<>    <Heading />     <ArrRq11 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq12()
// {
//   useDocumentTitle('Total numbers with no repeated digits in a range')
//   return (<>    <Heading />     <ArrRq12 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArRq13()
// {
//   useDocumentTitle('Difference Array | Range update query in O(1)')
//   return (<>    <Heading />     <ArrRq13 /> <ScrollToTop />  <Footer /> </>)

// }



// function ArSS()
// {
//   useDocumentTitle('Sorting And Searching')
//   return (<>    <Heading />     <ArrSSind /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS1()
// {
//   useDocumentTitle('Alternative Sorting')
//   return (<>    <Heading />     <ArrSS1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS2()
// {
//   useDocumentTitle('Sort an array according to absolute difference with given value')
//   return (<>    <Heading />     <ArrSS2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS3()
// {
//   useDocumentTitle('Merge an array of size n into another array of size m+n')
//   return (<>    <Heading />     <ArrSS3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS4()
// {
//   useDocumentTitle('Sort 1 to N by swapping adjacent elements')
//   return (<>    <Heading />     <ArrSS4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS5()
// {
//   useDocumentTitle('Sort elements by frequency')
//   return (<>    <Heading />     <ArrSS5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS6()
// {
//   useDocumentTitle('Two elements whose sum is closest to zero')
//   return (<>    <Heading />     <ArrSS6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS7()
// {
//   useDocumentTitle('Minimum number of swaps required to sort an array')
//   return (<>    <Heading />     <ArrSS7 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS8()
// {
//   useDocumentTitle('Search, insert and delete in an unsorted array')
//   return (<>    <Heading />     <ArrSS8 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS9()
// {
//   useDocumentTitle('Searching in an array where adjacent differ by at most k')
//   return (<>    <Heading />     <ArrSS9 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS10()
// {
//   useDocumentTitle('Find the element that appears once')
//   return (<>    <Heading />     <ArrSS10 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS11()
// {
//   useDocumentTitle('Leaders in an array')
//   return (<>    <Heading />     <ArrSS11 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS12()
// {
//   useDocumentTitle('Check if an array has a majority element')
//   return (<>    <Heading />     <ArrSS12 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArSS13()
// {
//   useDocumentTitle('Find a Fixed Point in a given array')
//   return (<>    <Heading />     <ArrSS13 /> <ScrollToTop />  <Footer /> </>)

// }


// function ArOp()
// {
//   useDocumentTitle('Optimization Problem')
//   return (<>    <Heading />     <ArrOPInd /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp1()
// {
//   useDocumentTitle('Largest Sum Contiguous Subarray')
//   return (<>    <Heading />     <ArrOP1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp2()
// {
//   useDocumentTitle('Find the subarray with least average')
//   return (<>    <Heading />     <ArrOP2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp3()
// {
//   useDocumentTitle('Minimize the maximum difference between the heights')
//   return (<>    <Heading />     <ArrOP3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp4()
// {
//   useDocumentTitle('Maximum Sum Increasing Subsequence')
//   return (<>    <Heading />     <ArrOP4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp5()
// {
//   useDocumentTitle('Find maximum average subarray of k length')
//   return (<>    <Heading />     <ArrOP5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp6()
// {
//   useDocumentTitle('Number of subsets with product less than k')
//   return (<>    <Heading />     <ArrOP6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp7()
// {
//   useDocumentTitle('Find the smallest positive integer value that cannot be represented as sum of any subset of a given array')
//   return (<>    <Heading />     <ArrOP7 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp8()
// {
//   useDocumentTitle('Size of The Subarray With Maximum Sum')
//   return (<>    <Heading />     <ArrOP8 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp9()
// {
//   useDocumentTitle('Find minimum difference between any two elements')
//   return (<>    <Heading />     <ArrOP9 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp10()
// {
//   useDocumentTitle('Space optimization using bit manipulations')
//   return (<>    <Heading />     <ArrOP10 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp11()
// {
//   useDocumentTitle('Longest Span with same Sum in two Binary arrays')
//   return (<>    <Heading />     <ArrOP11 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp12()
// {
//   useDocumentTitle('Maximum profit by buying and selling a share at most twice')
//   return (<>    <Heading />     <ArrOP12 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArOp13()
// {
//   useDocumentTitle('Find the minimum distance between two numbers')
//   return (<>    <Heading />     <ArrOP13 /> <ScrollToTop />  <Footer /> </>)

// }


// function ArMat()
// {
//   useDocumentTitle('Matrix')
//   return (<>    <Heading />     <ArrMat /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat1()
// {
//   useDocumentTitle('Rotate Matrix Elements')
//   return (<>    <Heading />     <ArrMat1 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat2()
// {
//   useDocumentTitle('Rotate a matrix by 90 degree without using any extra space')
//   return (<>    <Heading />     <ArrMat2 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat3()
// {
//   useDocumentTitle('Turn an image by 90 degree')
//   return (<>    <Heading />     <ArrMat3 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat4()
// {
//   useDocumentTitle('Check if all rows of a matrix are circular rotations of each other')
//   return (<>    <Heading />     <ArrMat4 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat5()
// {
//   useDocumentTitle('Find the row with maximum number of 1s')
//   return (<>    <Heading />     <ArrMat5 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat6()
// {
//   useDocumentTitle('Matrix Multiplication | Recursive')
//   return (<>    <Heading />     <ArrMat6 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat7()
// {
//   useDocumentTitle('Program for scalar multiplication of a matrix')
//   return (<>    <Heading />     <ArrMat7 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat8()
// {
//   useDocumentTitle('Find distinct elements common to all rows of a matrix')
//   return (<>    <Heading />     <ArrMat8 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat9()
// {
//   useDocumentTitle('Find maximum element of each row in a matrix')
//   return (<>    <Heading />     <ArrMat9 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat10()
// {
//   useDocumentTitle('Shift matrix elements row-wise by k')
//   return (<>    <Heading />     <ArrMat10 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat11()
// {
//   useDocumentTitle('Print a given matrix in counter-clock wise spiral form')
//   return (<>    <Heading />     <ArrMat11 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat12()
// {
//   useDocumentTitle('Maximum path sum in matrix')
//   return (<>    <Heading />     <ArrMat12 /> <ScrollToTop />  <Footer /> </>)

// }
// function ArMat13()
// {
//   useDocumentTitle('Move matrix elements in given direction and add elements with same value')
//   return (<>    <Heading />     <ArrMat13 /> <ScrollToTop />  <Footer /> </>)

// }
// function BInd()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BinInd /> <ScrollToTop />  <Footer /> </>)

// }
// function BtCind()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCCInd /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC1()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC1 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC2()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC2 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC3()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC3 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC4()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC4 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC5()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC5 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC6()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC7 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC8()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC8 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC9()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC9 /> <ScrollToTop />  <Footer /> </>)

// }
// function BtC10()
// {
//   useDocumentTitle('Binary Tree')
//   return (<>    <Heading />     <BtCC10 /> <ScrollToTop />  <Footer /> </>)

// }




function App()
{


  return (
    <>

      <div className="App">
        <Router>
          <div className='app'></div>
          <Switch>
            <Route exact path='/category' component={Meny}></Route>
            <Route exact path='/category/c' component={Cq}></Route>
            <Route exact path='/category/python' component={Py}></Route>
            <Route exact path='/category/cpp' component={Cps}></Route>
            <Route exact path='/category/java' component={Jav}></Route>
            <Route exact path='/category/java' component={Jav}></Route>
            <Route exact path='/category/c/introduction' component={C_intro}></Route>
            <Route exact path='/category/c/Basic-Computer-Components' component={Bas}></Route>
            <Route exact path='/category/c/Flow-Chart' component={Chart}></Route>
            <Route exact path='/category/c/Pseudo-Codes' component={Psu}></Route>
            <Route exact path='/category/c/tentime' component={Ten}></Route>
            <Route exact path='/category/c/Template' component={Temps}></Route>
            <Route exact path='/category/c/Function' component={Fun}></Route>
            <Route exact path='/category/c/data-types' component={Dat}></Route>
            <Route exact path='/category/c/scopes-of-variable' component={Scope}></Route>
            <Route exact path='/category/c/Behind-the-Scenes' component={Bts}></Route>
            <Route exact path='/category/c/Keywords' component={Wrd}></Route>
            <Route exact path='/category/c/loops' component={Lo}></Route>
            <Route exact path='/category/c/ternary-operator' component={T_p}></Route>
            <Route exact path='/category/c/Print-a-NooB-Geeks-10-times' component={T_t}></Route>
            <Route exact path='/category/c/Can-main-function-of-any-other-data-types' component={Ma}></Route>
            <Route exact path='/category/c/Print-sum-of-odd-number-till-N' component={Odd}></Route>
            <Route exact path='/category/c/Check-Prime-or-Not' component={Eighte}></Route>
            <Route exact path='/category/c/Print-number-Pyramind-Pattern' component={Nint}></Route>
            <Route exact path='/category/c/Print alphabet pyramid pattern' component={Twent}></Route>
            <Route exact path='/category/c/Print diamond Pyramind Pattern' component={TwentO}></Route>
            <Route exact path='/category/c/Linear' component={TwentTw}></Route>
            <Route exact path='/category/c/concepts of coding' component={Cod}></Route>
            <Route exact path='/category/c/Print largest of N' component={Tf}></Route>
            <Route exact path='/category/c/Print sq rt of N' component={Tsi}></Route>
            <Route exact path='/category/c/Find Mean' component={Ts}></Route>
            <Route exact path='/category/c/Decimal-binary' component={Te}></Route>
            <Route exact path='/category/c/array' component={Ar}></Route>
            <Route exact path='/category/c/Print n number using array' component={Th}></Route>
            <Route exact path='/category/c/algorithm' component={Alg}></Route>
            <Route exact path='/category/c/binary-search' component={Bin}></Route>
            <Route exact path='/category/c/Linear search' component={Tht}></Route>
            <Route exact path='/category/c/Selection sort' component={Thf}></Route>
            <Route exact path='/category/c/Insertion Sort' component={Thfi}></Route>
            <Route exact path='/category/c/Swapping-variables' component={Ths}></Route>
            <Route exact path='/category/c/print ncr number' component={Thse}></Route>
            <Route exact path='/category/c/Program to Merge the Elements of 2 Sorted Array' component={The}></Route>
            <Route exact path='/category/c/Pointer' component={Ptr}></Route>
            <Route exact path='/category/c/Bubble sort using pointer' component={Fo}></Route>
            <Route exact path='/category/c/Two Dimensional Array' component={Td}></Route>
            <Route exact path='/category/c/Rotate an array by 90 degree' component={Rot}></Route>
            <Route exact path='/category/c/String' component={St}></Route>
            <Route exact path='/category/c/String Reverse' component={St_re}></Route>
            <Route exact path='/category/c/ sum of n numbers using recurssion' component={Ft_o}></Route>
            <Route exact path='/category/c/ Count_multicharacters' component={Ft_t}></Route>
            <Route exact path='/category/c/ substring from string' component={Ft_th}></Route>
            <Route exact path='/category/c/ toggle string' component={Ft_fo}></Route>
            <Route exact path='/category/c/ split string by space into words' component={Ft_fi}></Route>
            <Route exact path='/category/c/recursion' component={Ft_si}></Route>
            <Route exact path='/category/c/factorial' component={Ft_se}></Route>
            <Route exact path='/category/c/Sum of Natural Numbers using Recursion' component={Ft_e}></Route>
            <Route exact path='/category/c/ Array reverse Using Recurssion' component={Ft_n}></Route>
            <Route exact path='/category/c/Binary search using recursion' component={Si}></Route>
            <Route exact path='/category/c/Rat in a maze' component={Rim}></Route>
            <Route exact path='/category/c/stack' component={Sta}></Route>
            <Route exact path='/category/c/queue' component={Qu}></Route>
            <Route exact path='/category/c/linked list' component={Ll}></Route>
            <Route exact path='/category/c/n-queen -problem' component={St_t}></Route>
            <Route exact path='/category/c/Recursion Permutation Lexicogrpahical Order' component={St_th}></Route>
            <Route exact path='/category/c/DMA' component={Dma}></Route>
            <Route exact path='/category/c/dictionary_order' component={Si_f}></Route>

            <Route exact path='/category/python/Introduction' component={Py_intro}></Route>
            <Route exact path='/category/python/Input and Output' component={Py_io}></Route>
            <Route exact path='/category/python/varibles' component={Py_var}></Route>
            <Route exact path='/category/python/loop' component={Py_loop}></Route>
            <Route exact path='/category/python/Alphabet pattern' component={Py_Ap}></Route>
            <Route exact path='/category/python/Number pattern' component={Py_Np}></Route>
            <Route exact path='/category/python/Data types' component={Py_dt}></Route>
            <Route exact path='/category/python/String' component={Py_str}></Route>
            <Route exact path='/category/python/Least_String' component={Py_ls}></Route>
            <Route exact path='/category/python/Snake_Pascal' component={Py_sp}></Route>
            <Route exact path='/category/python/Reverse string' component={Py_rs}></Route>
            <Route exact path='/category/python/Palindrome' component={Py_pal}></Route>
            <Route exact path='/category/python/find  substring of a string' component={Py_sub}></Route>
            <Route exact path='/category/python/List' component={Py_li}></Route>
            <Route exact path='/category/python/Reverse List' component={Py_rl}></Route>
            <Route exact path='/category/python/Second largest' component={Py_sl}></Route>
            <Route exact path='/category/python/Sort list' component={Py_sli}></Route>
            <Route exact path='/category/python/Cloning' component={Py_cl}></Route>
            <Route exact path='/category/python/Tuple' component={Py_tu}></Route>
            <Route exact path='/category/python/Python program to create a list of tuples from the given list having the number and its cube in each tuple' component={Py_tu_c}></Route>
            <Route exact path='/category/python/Closest Pair to Kth index element in Tuple' component={Py_tu_ct}></Route>
            <Route exact path='/category/python/All pair combinations of 2 tuples' component={Py_tu_pc}></Route>
            <Route exact path='/category/python/Convert Nested Tuple to Custom Key Dictionary' component={Py_tu_nt}></Route>
            <Route exact path='/category/python/program to sort a list of tuples by second Item' component={Py_tu_st}></Route>
            <Route exact path='/category/python/sets' component={Py_st}></Route>
            <Route exact path='/category/python/Dictionary' component={Py_dic}></Route>
            <Route exact path='/category/python/ Extract Unique values dictionary values' component={Py_dic_un}></Route>
            <Route exact path='/category/python/ Ways to remove a key from dictionary' component={Py_dic_kd}></Route>
            <Route exact path='/category/python/Handling missing keys in Python dictionaries' component={Py_dic_mk}></Route>
            <Route exact path='/category/python/Python Dictionary to find mirror characters in a string' component={Py_dic_mc}></Route>
            <Route exact path='/category/python/Possible Words using given characters in Python' component={Py_dic_pw}></Route>
            <Route exact path='/category/python/Arrays in Python' component={Py_arr}></Route>
            <Route exact path='/category/python/N-Queen Problem in Python' component={Py_que}></Route>
            <Route exact path='/category/python/Rat in a maze' component={Py_rm}></Route>
            <Route exact path='/category/python/Check Prime' component={Py_cp}></Route>
            <Route exact path='/category/python/Oops' component={Py_op}></Route>
            <Route exact path='/category/python/Class object and member' component={Py_co}></Route>
            <Route exact path='/category/python/Data hiding and print object' component={Py_dh}></Route>
            <Route exact path='/category/python/Inheritance' component={Py_inh}></Route>
            <Route exact path='/category/python/Polymorphism' component={Py_poly}></Route>
            <Route exact path='/category/python/Constructors' component={Py_const}></Route>
            <Route exact path='/category/python/Destructors' component={Py_dest}></Route>
            <Route exact path='/category/python/Metaprogramming' component={Py_meta}></Route>
            <Route exact path='/category/python/Class and attributes' component={Py_ca}></Route>
            <Route exact path='/category/python/Exception' component={Py_ex}></Route>
            <Route exact path='/category/python/User Defined Exception' component={Py_ud}></Route>
            <Route exact path='/category/python/Defining Clean Up Actions' component={Py_cua}></Route>
            <Route exact path='/category/python/Python Try Except' component={Py_pte}></Route>
            <Route exact path='/category/python/Dequeuq' component={Py_dq}></Route>
            <Route exact path='/category/python/Heap' component={Py_hp}></Route>
            <Route exact path='/category/python/Numpy' component={Py_np}></Route>
            <Route exact path='/category/python/Sorting searching and counting' component={Py_sss}></Route>
            <Route exact path='/category/python/Pandas' component={Py_pan}></Route>
            <Route exact path='/category/python/Pandas series' component={Py_ps}></Route>
            <Route exact path='/category/python/creating data frame' component={Py_df}></Route>
            <Route exact path='/category/python/Conersion data frame' component={Py_pc}></Route>
            <Route exact path='/category/python/Machine learning' component={Py_ml}></Route>
            <Route exact path='/category/python/Modules' component={Py_mod}></Route>
            <Route exact path='/category/python/Calender module' component={Py_cal}></Route>
            <Route exact path='/category/python/OS Module' component={Py_os}></Route>
            <Route exact path='/category/python/Mongo_Db' component={Py_db}></Route>
            <Route exact path='/category/python/Import modules' component={Py_imp}></Route>
            <Route exact path='/category/python/Django' component={Py_djan}></Route>
            <Route exact path='/category/python/Data_analysis' component={Py_dta_anal}></Route>


            <Route exact path='/category/cpp/introduction' component={Cpp_intro}></Route>
            <Route exact path='/category/cpp/Basics of computer operation' component={Cpp_bcc}></Route>
            <Route exact path='/category/cpp/Flow chart and Pseudocode' component={Cpp_flow}></Route>
            <Route exact path='/category/cpp/Print hello world 10 time by flow chart and pseudocode' component={Cpp_hello}></Route>
            <Route exact path='/category/cpp/Check Prime or not by flow  chart and pseudocode' component={Cpp_pri}></Route>
            <Route exact path='/category/cpp/Sum of N natural numbers by flow chart and pseudocode' component={Cpp_sum}></Route>
            <Route exact path='/category/cpp/Concepts of Coding' component={Cpp_concept}></Route>
            <Route exact path='/category/cpp/Template' component={Cpp_temp}></Route>
            <Route exact path='/category/cpp/Keywords Variable and Constant' component={Cpp_kwd}></Route>
            <Route exact path='/category/cpp/Loops' component={Cpp_loop}></Route>
            <Route exact path='/category/cpp/Cpp program to print all Even and Odd numbers from 1 to N' component={Cpp_even}></Route>
            <Route exact path='/category/cpp/Program to print Arithmetic Progression series' component={Cpp_ap}></Route>
            <Route exact path='/category/cpp/Write a program to check whether a number is prime or not' component={Cpp_primed}></Route>
            <Route exact path='/category/cpp/Program for Decimal to Binary Conversion' component={Cpp_d_b}></Route>
            <Route exact path='/category/cpp/Program to calculate value of nCr' component={Cpp_cr}></Route>
            <Route exact path='/category/cpp/Alphabet pattern' component={Cpp_alp}></Route>
            <Route exact path='/category/cpp/Data types' component={Cpp_dt}></Route>
            <Route exact path='/category/cpp/Array' component={Cpp_arr}></Route>
            <Route exact path='/category/cpp/Write a program to reverse an array or string' component={Cpp_arr_rev}></Route>
            <Route exact path='/category/cpp/Write a program to do linear search' component={Cpp_linear}></Route>
            <Route exact path='/category/cpp/Write a program to do Bubble sort' component={Cpp_bubble}></Route>
            <Route exact path='/category/cpp/Write a program to do Selection sort' component={Cpp_selection}></Route>
            <Route exact path='/category/cpp/Pointers' component={Cpp_ptr}></Route>
            <Route exact path='/category/cpp/Default Argument' component={Cpp_da}></Route>
            <Route exact path='/category/cpp/String' component={Cpp_str}></Route>
            <Route exact path='/category/cpp/Rotate matrix by 90degree anticlockwise' component={Cpp_rot}></Route>
            <Route exact path='/category/cpp/Reverse the string' component={Cpp_st_rev}></Route>
            <Route exact path='/category/cpp/Different methods to reverse a string in C/C++' component={Cpp_m_str}></Route>
            <Route exact path='/category/cpp/Remove duplicates from a given string' component={Cp_dpStr}></Route>
            <Route exact path='/category/cpp/Write a program to print all permutations of a given string' component={Cpp_perm}></Route>
            <Route exact path='/category/cpp/Program to toggle all characters in a string' component={Cp_tog}></Route>
            <Route exact path='/category/cpp/Recurssion in C++' component={Cp_recur}></Route>
            <Route exact path='/category/cpp/Recursive program to check if number is palindrome or not C++' component={Cp_pal}></Route>
            <Route exact path='/category/cpp/Dynamic Memory Allocation' component={Cp_dma}></Route>
            <Route exact path='/category/cpp/Rat in a Maze C++' component={Cp_rmz}></Route>
            <Route exact path='/category/cpp/C++ Program to Solve N-Queen Problem' component={Cp_nq}></Route>
            <Route exact path='/category/cpp/Oops in C++' component={Cp_op}></Route>
            <Route exact path='/category/cpp/Class and its member C++' component={Cp_cls}></Route>
            <Route exact path='/category/cpp/Difference between Inheritance and Polymorphism' component={Cp_inh}></Route>
            <Route exact path='/category/cpp/Linked list' component={Cp_lnk}></Route>
            <Route exact path='/category/cpp/Delete a Linked List node at a given position' component={Cp_dt}></Route>
            <Route exact path='/category/cpp/Write a function to delete a Linked List' component={Cp_wt}></Route>
            <Route exact path='/category/cpp/Write a function to get the intersection point of two Linked Lists' component={Cp_inter}></Route>
            <Route exact path='/category/cpp/Merge two sorted linked lists' component={Cp_merge}></Route>
            <Route exact path='/category/cpp/Stack in C++' component={Cp_stack}></Route>
            <Route exact path='/category/cpp/Reverse Stack in C++' component={Cp_stk_rev}></Route>
            <Route exact path='/category/cpp/Infix to Postfix' component={Cp_inf}></Route>
            <Route exact path='/category/cpp/The stock span problem' component={Cp_stock}></Route>
            <Route exact path='/category/cpp/The Celebrity Problem' component={Cp_celb}></Route>
            <Route exact path='/category/cpp/Tower of hanoi' component={Cp_th}></Route>
            <Route exact path='/category/cpp/Sort the stack' component={Cp_sort}></Route>
            <Route exact path='/category/cpp/queue' component={Cp_quee}></Route>
            <Route exact path='/category/cpp/vector' component={Cp_vct}></Route>
            <Route exact path='/category/cpp/map' component={Cp_mp}></Route>


            <Route exact path='/category/java/Introduction' component={Jv_mp}></Route>
            <Route exact path='/category/java/Basics of Computer' component={Jv_bcc}></Route>
            <Route exact path='/category/java/Flow-Chart and Pseudocode' component={Jv_flow}></Route>
            <Route exact path='/category/java/Java - Print hello world 10 time by flow chart and pseudocode' component={Jv_hello}></Route>
            <Route exact path='/category/java/java - Check Prime or not by flow  chart and pseudocode' component={Jv_Prime}></Route>
            <Route exact path='/category/java/Java - Sum of N natural numbers by flow chart and pseudocode' component={Jv_sum}></Route>
            <Route exact path='/category/java/Java - Basic of coding' component={Jv_basic}></Route>
            <Route exact path='/category/java/Java - Basic and Template of Java' component={Jv_temp}></Route>
            <Route exact path='/category/java/Java - Input and Output' component={Jv_IO}></Route>
            <Route exact path='/category/java/Java - Variable Constant and Keywords' component={Jv_vck}></Route>
            <Route exact path='/category/java/Is main method compulsory in Java' component={Jv_main}></Route>
            <Route exact path='/category/java/Data type' component={Jv_dt}></Route>
            <Route exact path='/category/java/Loops in Java' component={Jv_loop}></Route>
            <Route exact path='/category/java/Java Program to Print Natural Numbers from 1 to N' component={Jv_N}></Route>
            <Route exact path='/category/java/Java Program to Print AP till N' component={Jv_ap}></Route>
            <Route exact path='/category/java/Java Conditional statement' component={Jv_cs}></Route>
            <Route exact path='/category/java/Java-Check Prime or not' component={Jv_checkP}></Route>
            <Route exact path='/category/java/Java Convert Decimal to Binary' component={Jv_Bd}></Route>
            <Route exact path='/category/java/Java program to find the value' component={Jv_nc}></Route>
            <Route exact path='/category/java/Program to print the pattern' component={Jv_Pattern}></Route>
            <Route exact path='/category/java/Java Arrays' component={Jv_arr}></Route>
            <Route exact path='/category/java/Java Arrays Reverse' component={Jv_arrRev}></Route>
            <Route exact path='/category/java/Java Linear search' component={Jv_ls}></Route>
            <Route exact path='/category/java/Java matrix clockwise' component={Jv_mat}></Route>
            <Route exact path='/category/java/Java-Bubble sorting' component={Jv_bs}></Route>
            <Route exact path='/category/java/Java-Selction sorting' component={Jv_sel}></Route>
            <Route exact path='/category/java/Java-Java Refrence' component={Jv_ref}></Route>
            <Route exact path='/category/java/Java-String' component={Jv_str}></Route>
            <Route exact path='/category/java/String vs StringBuilder vs StringBuffer in Java' component={Jv_sss}></Route>
            <Route exact path='/category/java/String Reverse in Java' component={Jv_strRev}></Route>
            <Route exact path='/category/java/Java Program To Find Maximum And Minimum Occurring Character' component={Jv_maxChar}></Route>
            <Route exact path='/category/java/Remove duplicates from a given string' component={Jv_Dup}></Route>
            <Route exact path='/category/java/Toggle the given string' component={Jv_tog}></Route>
            <Route exact path='/category/java/Recurssion in java' component={Jv_rec}></Route>
            <Route exact path='/category/java/Check given number is palindrome or not' component={Jv_pal}></Route>
            <Route exact path='/category/java/Find the permutation of string' component={Jv_perm}></Route>
            <Route exact path='/category/java/Rat in maze' component={Jv_rmz}></Route>
            <Route exact path='/category/java/N-queen problem' component={Jv_nque}></Route>
            <Route exact path='/category/java/OOPS in java' component={Jv_oops}></Route>
            <Route exact path='/category/java/DMA- dynamic memory allocation in java' component={Jv_dma}></Route>
            <Route exact path='/category/java/Class and its members' component={Jv_class}></Route>
            <Route exact path='/category/java/Difference between method overloading and method overriding in java' component={Jv_method}></Route>
            <Route exact path='/category/java/Exceptional handling' component={Jv_exce}></Route>
            <Route exact path='/category/java/Abstract list' component={Jv_abs}></Route>
            <Route exact path='/category/java/Arraylist' component={Jv_arrL}></Route>
            <Route exact path='/category/java/Linked list' component={Jv_ll}></Route>
            <Route exact path='/category/java/intersection of two linked list' component={Jv_int}></Route>
            <Route exact path='/category/java/delete whole linked list' component={Jv_del}></Route>
            <Route exact path='/category/java/delete an element from an array from a specified location' component={Jv_posD}></Route>
            <Route exact path='/category/java/merge two linked list' component={Jv_merge}></Route>
            <Route exact path='/category/java/stack in java' component={Jv_stk}></Route>
            <Route exact path='/category/java/Reverse the stack in java' component={Jv_stkRev}></Route>
            <Route exact path='/category/java/Infix to Postfix' component={Jv_stIf}></Route>
            <Route exact path='/category/java/The stock problem' component={Jv_stock}></Route>
            <Route exact path='/category/java/The Celebrity problem' component={Jv_cleb}></Route>
            <Route exact path='/category/java/Tower of hanoi' component={Jv_toh}></Route>
            <Route exact path='/category/java/sort the stack' component={Jv_sort}></Route>
            <Route exact path='/category/java/queue in java' component={Jva_que}></Route>
            <Route exact path='/category/java/Set in java' component={Jv_set}></Route>
            <Route exact path='/category/java/merge set in java' component={Jv_mrg}></Route>
            <Route exact path='/category/java/Vector in java' component={Jv_vec}></Route>
            <Route exact path='/category/java/Map in java' component={Jv_map}></Route>




            <Route exact path='/category/Puzzels' component={Pu}></Route>
            <Route exact path='/category/Puzzels/Puzzel1' component={Pu1}></Route>
            <Route exact path='/category/Puzzels/Puzzel2' component={Pu2}></Route>
            <Route exact path='/category/Puzzels/Puzzel3' component={Puth}></Route>
            <Route exact path='/category/Puzzels/Puzzel4' component={Pufo}></Route>
            <Route exact path='/category/Puzzels/Puzzel5' component={Pufi}></Route>
            <Route exact path='/category/Puzzels/Puzzel6' component={Pusi}></Route>
            <Route exact path='/category/Puzzels/Puzzel7' component={Puse}></Route>
            <Route exact path='/category/Puzzels/Puzzel8' component={Pusei}></Route>
            <Route exact path='/category/Puzzels/Puzzel9' component={Pusni}></Route>
            <Route exact path='/category/Puzzels/Puzzel10' component={Puste}></Route>
            <Route exact path='/category/Puzzels/Puzzel11' component={Pusel}></Route>
            <Route exact path='/category/Puzzels/Puzzel12' component={Pu12}></Route>
            <Route exact path='/category/Puzzels/Puzzel13' component={Pu13}></Route>
            <Route exact path='/category/Puzzels/Puzzel14' component={Pu14}></Route>
            <Route exact path='/category/Puzzels/Puzzel15' component={Pu15}></Route>
            <Route exact path='/category/Puzzels/Puzzel16' component={Pu16}></Route>
            <Route exact path='/category/Puzzels/Puzzel17' component={Pu17}></Route>
            <Route exact path='/category/Puzzels/Puzzel18' component={Pu18}></Route>
            <Route exact path='/category/Puzzels/Puzzel19' component={Pu19}></Route>
            <Route exact path='/category/Puzzels/Puzzel20' component={Pu20}></Route>
            <Route exact path='/category/Puzzels/Puzzel21' component={Pu21}></Route>
            <Route exact path='/category/Puzzels/Puzzel22' component={Pu22}></Route>
            <Route exact path='/category/Puzzels/Puzzel23' component={Pu23}></Route>
            <Route exact path='/category/Puzzels/Puzzel24' component={Pu24}></Route>
            <Route exact path='/category/Puzzels/Puzzel25' component={Pu25}></Route>
            <Route exact path='/category/Puzzels/Puzzel26' component={Pu26}></Route>
            <Route exact path='/category/Puzzels/Puzzel27' component={Pu27}></Route>
            <Route exact path='/category/Puzzels/Puzzel28' component={Pu28}></Route>
            <Route exact path='/category/Puzzels/Puzzel29' component={Pu29}></Route>
            <Route exact path='/category/Puzzels/Puzzel30' component={Pu30}></Route>
            <Route exact path='/category/Puzzels/Puzzel31' component={Pu31}></Route>
            <Route exact path='/category/Puzzels/Puzzel32' component={Pu32}></Route>
            <Route exact path='/category/Puzzels/Puzzel33' component={Pu33}></Route>
            <Route exact path='/category/Puzzels/Puzzel34' component={Pu34}></Route>
            <Route exact path='/category/Puzzels/Puzzel35' component={Pu35}></Route>
            <Route exact path='/category/Puzzels/Puzzel36' component={Pu36}></Route>
            <Route exact path='/category/Puzzels/Puzzel37' component={Pu37}></Route>
            <Route exact path='/category/Puzzels/Puzzel38' component={Pu38}></Route>
            <Route exact path='/category/Puzzels/Puzzel39' component={Pu39}></Route>
            <Route exact path='/category/Puzzels/Puzzel40' component={Pu40}></Route>
            <Route exact path='/category/Puzzels/Puzzel41' component={Pu41}></Route>
            <Route exact path='/category/Puzzels/Puzzel42' component={Pu42}></Route>
            <Route exact path='/category/Puzzels/Puzzel43' component={Pu43}></Route>
            <Route exact path='/category/Puzzels/Puzzel44' component={Pu44}></Route>
            <Route exact path='/category/Puzzels/Puzzel45' component={Pu45}></Route>



            <Route exact path='/category/Interview question' component={IntQ}></Route>
            <Route exact path='/category/Interview question/1' component={Some}></Route>
            <Route exact path='/category/Interview question/2' component={Iqs2}></Route>
            <Route exact path='/category/Interview question/3' component={Iqs3}></Route>
            <Route exact path='/category/Interview question/4' component={Iqs4}></Route>
            <Route exact path='/category/Interview question/5' component={Iqs5}></Route>
            <Route exact path='/category/Interview question/6' component={Iqs6}></Route>
            <Route exact path='/category/Interview question/7' component={Iqs7}></Route>
            <Route exact path='/category/Interview question/8' component={Iqs8}></Route>
            <Route exact path='/category/Interview question/9' component={Iqs9}></Route>
            <Route exact path='/category/Interview question/10' component={Iqs10}></Route>




            <Route exact path='/category/br' component={Brs1}></Route>
            <Route exact path='/category/Order' component={Ord}></Route>


            <Route exact path='/category/Amazon' component={Amz}></Route>
            <Route exact path='/category/Google' component={Goo}></Route>
            <Route exact path='/category/Snapdeal' component={Snd}></Route>
            <Route exact path='/category/Qualcomm' component={Qlc}></Route>
            <Route exact path='/category/Samsung' component={Smsun}></Route>
            <Route exact path='/category/Flipkart' component={Flpk}></Route>
            <Route exact path='/category/Make-My-Trip' component={Makemy}></Route>
            <Route exact path='/category/Goldman-Sachs' component={Goldman}></Route>
            <Route exact path='/category/Accolite' component={Acco}></Route>
            <Route exact path='/category/Yahoo' component={Yah}></Route>
            <Route exact path='/category/DE-Shaw' component={De}></Route>
            <Route exact path='/category/Microsoft' component={Micro}></Route>
            <Route exact path='/category/Paytm' component={Pytm}></Route>
            <Route exact path='/category/Ola' component={Ol}></Route>
            <Route exact path='/category/Cisco' component={Cis}></Route>




            <Route exact path='/category/Amazon Interview question 1' component={Am1}></Route>
            <Route exact path='/category/Amazon Interview question 2' component={Am2}></Route>
            <Route exact path='/category/Amazon Interview question 3' component={Am3}></Route>
            <Route exact path='/category/Amazon Interview question 4' component={Am4}></Route>
            <Route exact path='/category/Amazon Interview question 5' component={Am5}></Route>
            <Route exact path='/category/Amazon Interview question 6' component={Am6}></Route>
            <Route exact path='/category/Amazon Interview question 7' component={Am7}></Route>
            <Route exact path='/category/Amazon Interview question 8' component={Am8}></Route>
            <Route exact path='/category/Amazon Interview question 9' component={Am9}></Route>
            <Route exact path='/category/Amazon Interview question 10' component={Am10}></Route>
            <Route exact path='/category/Amazon Interview question 11' component={Am11}></Route>
            <Route exact path='/category/Amazon Interview question 12' component={Am12}></Route>
            <Route exact path='/category/Amazon Interview question 13' component={Am13}></Route>
            <Route exact path='/category/Amazon Interview question 14' component={Am14}></Route>
            <Route exact path='/category/Amazon Interview question 15' component={Am15}></Route>
            <Route exact path='/category/Amazon Interview question 16' component={Am16}></Route>
            <Route exact path='/category/Amazon Interview question 17' component={Am17}></Route>
            <Route exact path='/category/Amazon Interview question 18' component={Am18}></Route>
            <Route exact path='/category/Amazon Interview question 19' component={Am19}></Route>
            <Route exact path='/category/Amazon Interview question 20' component={Am20}></Route>


            <Route exact path='/category/Google Interview question 1' component={Gg1}></Route>
            <Route exact path='/category/Google Interview question 2' component={Gg2}></Route>
            <Route exact path='/category/Google Interview question 3' component={Gg3}></Route>
            <Route exact path='/category/Google Interview question 4' component={Gg4}></Route>
            <Route exact path='/category/Google Interview question 5' component={Gg5}></Route>
            <Route exact path='/category/Google Interview question 6' component={Gg6}></Route>
            <Route exact path='/category/Google Interview question 7' component={Gg7}></Route>
            <Route exact path='/category/Google Interview question 8' component={Gg8}></Route>
            <Route exact path='/category/Google Interview question 9' component={Gg9}></Route>
            <Route exact path='/category/Google Interview question 10' component={Gg10}></Route>
            <Route exact path='/category/Google Interview question 11' component={Gg11}></Route>
            <Route exact path='/category/Google Interview question 12' component={Gg12}></Route>
            <Route exact path='/category/Google Interview question 13' component={Gg13}></Route>
            <Route exact path='/category/Google Interview question 14' component={Gg14}></Route>
            <Route exact path='/category/Google Interview question 15' component={Gg15}></Route>



            <Route exact path='/category/Microsoft Interview question 1' component={Ms2}></Route>
            <Route exact path='/category/Microsoft Interview question 2' component={Ms3}></Route>
            <Route exact path='/category/Microsoft Interview question 3' component={Ms4}></Route>
            <Route exact path='/category/Microsoft Interview question 4' component={Ms5}></Route>
            <Route exact path='/category/Microsoft Interview question 5' component={Ms6}></Route>
            <Route exact path='/category/Microsoft Interview question 6' component={Ms7}></Route>
            <Route exact path='/category/Microsoft Interview question 7' component={Ms8}></Route>
            <Route exact path='/category/Microsoft Interview question 8' component={Ms9}></Route>
            <Route exact path='/category/Microsoft Interview question 9' component={Ms10}></Route>
            <Route exact path='/category/Microsoft Interview question 10' component={Ms11}></Route>
            <Route exact path='/category/Microsoft Interview question 11' component={Ms12}></Route>
            <Route exact path='/category/Microsoft Interview question 12' component={Ms13}></Route>
            <Route exact path='/category/Microsoft Interview question 13' component={Ms14}></Route>
            <Route exact path='/category/Microsoft Interview question 14' component={Ms15}></Route>
            <Route exact path='/category/Microsoft Interview question 15' component={Ms16}></Route>



            <Route exact path='/category/DE Shaw Interview question 1' component={Ds1}></Route>
            <Route exact path='/category/DE Shaw Interview question 2' component={Ds2}></Route>
            <Route exact path='/category/DE Shaw Interview question 3' component={Ds3}></Route>
            <Route exact path='/category/DE Shaw Interview question 4' component={Ds4}></Route>
            <Route exact path='/category/DE Shaw Interview question 5' component={Ds5}></Route>
            <Route exact path='/category/DE Shaw Interview question 6' component={Ds6}></Route>
            <Route exact path='/category/DE Shaw Interview question 7' component={Ds7}></Route>
            <Route exact path='/category/DE Shaw Interview question 8' component={Ds8}></Route>
            <Route exact path='/category/DE Shaw Interview question 9' component={Ds9}></Route>
            <Route exact path='/category/DE Shaw Interview question 10' component={Ds10}></Route>
            <Route exact path='/category/DE Shaw Interview question 11' component={Ds11}></Route>
            <Route exact path='/category/DE Shaw Interview question 12' component={Ds12}></Route>
            <Route exact path='/category/DE Shaw Interview question 13' component={Ds13}></Route>
            <Route exact path='/category/DE Shaw Interview question 14' component={Ds14}></Route>
            <Route exact path='/category/DE Shaw Interview question 15' component={Ds15}></Route>
            <Route exact path='/category/DE Shaw Interview question 16' component={Ds16}></Route>


            <Route exact path='/category/Accolite Interview question 1' component={Ac1}></Route>
            <Route exact path='/category/Accolite Interview question 2' component={Ac2}></Route>
            <Route exact path='/category/Accolite Interview question 3' component={Ac3}></Route>
            <Route exact path='/category/Accolite Interview question 4' component={Ac4}></Route>
            <Route exact path='/category/Accolite Interview question 5' component={Ac5}></Route>
            <Route exact path='/category/Accolite Interview question 6' component={Ac6}></Route>
            <Route exact path='/category/Accolite Interview question 7' component={Ac7}></Route>
            <Route exact path='/category/Accolite Interview question 8' component={Ac8}></Route>
            <Route exact path='/category/Accolite Interview question 9' component={Ac9}></Route>
            <Route exact path='/category/Accolite Interview question 10' component={Ac10}></Route>
            <Route exact path='/category/Accolite Interview question 11' component={Ac11}></Route>
            <Route exact path='/category/Accolite Interview question 12' component={Ac12}></Route>
            <Route exact path='/category/Accolite Interview question 13' component={Ac13}></Route>
            <Route exact path='/category/Accolite Interview question 14' component={Ac14}></Route>
            <Route exact path='/category/Accolite Interview question 15' component={Ac15}></Route>




            <Route exact path='/category/Yahoo Interview question 1' component={Yah1}></Route>
            <Route exact path='/category/Yahoo Interview question 2' component={Yah2}></Route>
            <Route exact path='/category/Yahoo Interview question 3' component={Yah3}></Route>
            <Route exact path='/category/Yahoo Interview question 4' component={Yah4}></Route>
            <Route exact path='/category/Yahoo Interview question 5' component={Yah5}></Route>
            <Route exact path='/category/Yahoo Interview question 6' component={Yah6}></Route>
            <Route exact path='/category/Yahoo Interview question 7' component={Yah7}></Route>
            <Route exact path='/category/Yahoo Interview question 8' component={Yah8}></Route>
            <Route exact path='/category/Yahoo Interview question 9' component={Yah9}></Route>
            <Route exact path='/category/Yahoo Interview question 10' component={Yah10}></Route>
            <Route exact path='/category/Yahoo Interview question 11' component={Yah11}></Route>
            <Route exact path='/category/Yahoo Interview question 12' component={Yah12}></Route>
            <Route exact path='/category/Yahoo Interview question 13' component={Yah13}></Route>
            <Route exact path='/category/Yahoo Interview question 14' component={Yah14}></Route>
            <Route exact path='/category/Yahoo Interview question 15' component={Yah15}></Route>



            <Route exact path='/category/Goldman Sachs Interview question 1' component={Gs1}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 2' component={Gs2}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 3' component={Gs3}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 4' component={Gs4}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 5' component={Gs5}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 6' component={Gs6}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 7' component={Gs7}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 8' component={Gs8}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 9' component={Gs9}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 10' component={Gs10}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 11' component={Gs11}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 12' component={Gs12}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 13' component={Gs13}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 14' component={Gs14}></Route>
            <Route exact path='/category/Goldman Sachs Interview question 15' component={Gs15}></Route>



            <Route exact path='/category/Make My Trip Interview question 1' component={Mmt1}></Route>
            <Route exact path='/category/Make My Trip Interview question 2' component={Mmt2}></Route>
            <Route exact path='/category/Make My Trip Interview question 3' component={Mmt3}></Route>
            <Route exact path='/category/Make My Trip Interview question 4' component={Mmt4}></Route>
            <Route exact path='/category/Make My Trip Interview question 5' component={Mmt4}></Route>
            <Route exact path='/category/Make My Trip Interview question 6' component={Mmt5}></Route>
            <Route exact path='/category/Make My Trip Interview question 7' component={Mmt6}></Route>
            <Route exact path='/category/Make My Trip Interview question 8' component={Mmt7}></Route>
            <Route exact path='/category/Make My Trip Interview question 9' component={Mmt9}></Route>
            <Route exact path='/category/Make My Trip Interview question 10' component={Mmt10}></Route>
            <Route exact path='/category/Make My Trip Interview question 11' component={Mmt11}></Route>
            <Route exact path='/category/Make My Trip Interview question 12' component={Mmt12}></Route>
            <Route exact path='/category/Make My Trip Interview question 13' component={Mmt13}></Route>
            <Route exact path='/category/Make My Trip Interview question 14' component={Mmt14}></Route>
            <Route exact path='/category/Make My Trip Interview question 15' component={Mmt15}></Route>

            <Route exact path='/category/Flikart Interview question 1' component={Flp1}></Route>
            <Route exact path='/category/Flikart Interview question 2' component={Flp2}></Route>
            <Route exact path='/category/Flikart Interview question 3' component={Flp3}></Route>
            <Route exact path='/category/Flikart Interview question 4' component={Flp4}></Route>
            <Route exact path='/category/Flikart Interview question 5' component={Flp5}></Route>
            <Route exact path='/category/Flikart Interview question 6' component={Flp6}></Route>
            <Route exact path='/category/Flikart Interview question 7' component={Flp7}></Route>
            <Route exact path='/category/Flikart Interview question 8' component={Flp8}></Route>
            <Route exact path='/category/Flikart Interview question 9' component={Flp9}></Route>
            <Route exact path='/category/Flikart Interview question 10' component={Flp10}></Route>
            <Route exact path='/category/Flikart Interview question 11' component={Flp11}></Route>
            <Route exact path='/category/Flikart Interview question 12' component={Flp12}></Route>
            <Route exact path='/category/Flikart Interview question 13' component={Flp13}></Route>
            <Route exact path='/category/Flikart Interview question 14' component={Flp14}></Route>
            <Route exact path='/category/Flikart Interview question 15' component={Flp15}></Route>

            <Route exact path='/category/Paytm Interview question 1' component={Ptm1}></Route>
            <Route exact path='/category/Paytm Interview question 2' component={Ptm2}></Route>
            <Route exact path='/category/Paytm Interview question 3' component={Ptm3}></Route>
            <Route exact path='/category/Paytm Interview question 4' component={Ptm4}></Route>
            <Route exact path='/category/Paytm Interview question 5' component={Ptm5}></Route>
            <Route exact path='/category/Paytm Interview question 6' component={Ptm6}></Route>
            <Route exact path='/category/Paytm Interview question 7' component={Ptm7}></Route>
            <Route exact path='/category/Paytm Interview question 8' component={Ptm8}></Route>
            <Route exact path='/category/Paytm Interview question 9' component={Ptm9}></Route>
            <Route exact path='/category/Paytm Interview question 10' component={Ptm10}></Route>
            <Route exact path='/category/Paytm Interview question 11' component={Ptm11}></Route>
            <Route exact path='/category/Paytm Interview question 12' component={Ptm12}></Route>
            <Route exact path='/category/Paytm Interview question 13' component={Ptm13}></Route>
            <Route exact path='/category/Paytm Interview question 14' component={Ptm14}></Route>


            <Route exact path='/category/Ola Cabs Interview question 1' component={Ol1}></Route>
            <Route exact path='/category/Ola Cabs Interview question 2' component={Ol2}></Route>
            <Route exact path='/category/Ola Cabs Interview question 3' component={Ol3}></Route>
            <Route exact path='/category/Ola Cabs Interview question 4' component={Ol4}></Route>
            <Route exact path='/category/Ola Cabs Interview question 5' component={Ol5}></Route>
            <Route exact path='/category/Ola Cabs Interview question 6' component={Ol6}></Route>
            <Route exact path='/category/Ola Cabs Interview question 8' component={Ol8}></Route>
            <Route exact path='/category/Ola Cabs Interview question 9' component={Ol9}></Route>
            <Route exact path='/category/Ola Cabs Interview question 10' component={Ol10}></Route>
            <Route exact path='/category/Ola Cabs Interview question 11' component={Ol11}></Route>
            <Route exact path='/category/Ola Cabs Interview question 10' component={Ol10}></Route>
            <Route exact path='/category/Ola Cabs Interview question 12' component={Ol12}></Route>
            <Route exact path='/category/Ola Cabs Interview question 13' component={Ol13}></Route>
            <Route exact path='/category/Ola Cabs Interview question 14' component={Ol14}></Route>
            <Route exact path='/category/Ola Cabs Interview question 15' component={Ol15}></Route>


            <Route exact path='/category/Cisco Interview question 1' component={Cisc1}></Route>
            <Route exact path='/category/Cisco Interview question 2' component={Cisc2}></Route>
            <Route exact path='/category/Cisco Interview question 3' component={Cisc3}></Route>
            <Route exact path='/category/Cisco Interview question 4' component={Cisc4}></Route>
            <Route exact path='/category/Cisco Interview question 5' component={Cisc5}></Route>
            <Route exact path='/category/Cisco Interview question 6' component={Cisc6}></Route>
            <Route exact path='/category/Cisco Interview question 7' component={Cisc7}></Route>
            <Route exact path='/category/Cisco Interview question 8' component={Cisc8}></Route>
            <Route exact path='/category/Cisco Interview question 9' component={Cisc9}></Route>
            <Route exact path='/category/Cisco Interview question 10' component={Cisc10}></Route>
            <Route exact path='/category/Cisco Interview question 11' component={Cisc11}></Route>
            <Route exact path='/category/Cisco Interview question 12' component={Cisc12}></Route>
            <Route exact path='/category/Cisco Interview question 13' component={Cisc13}></Route>
            <Route exact path='/category/Cisco Interview question 14' component={Cisc14}></Route>

            <Route exact path='/category/Samsung Interview question 1' component={Smsu1}></Route>
            <Route exact path='/category/Samsung Interview question 2' component={Smsu2}></Route>
            <Route exact path='/category/Samsung Interview question 3' component={Smsu3}></Route>
            <Route exact path='/category/Samsung Interview question 4' component={Smsu4}></Route>
            <Route exact path='/category/Samsung Interview question 5' component={Smsu5}></Route>
            <Route exact path='/category/Samsung Interview question 6' component={Smsu6}></Route>
            <Route exact path='/category/Samsung Interview question 7' component={Smsu7}></Route>
            <Route exact path='/category/Samsung Interview question 8' component={Smsu8}></Route>
            <Route exact path='/category/Samsung Interview question 9' component={Smsu9}></Route>
            <Route exact path='/category/Samsung Interview question 10' component={Smsu10}></Route>
            <Route exact path='/category/Samsung Interview question 11' component={Smsu11}></Route>
            <Route exact path='/category/Samsung Interview question 12' component={Smsu12}></Route>
            <Route exact path='/category/Samsung Interview question 12' component={Smsu12}></Route>
            <Route exact path='/category/Samsung Interview question 13' component={Smsu13}></Route>
            <Route exact path='/category/Samsung Interview question 14' component={Smsu14}></Route>



            <Route exact path='/category/Qualcomm Interview question 1' component={Qualc1}></Route>
            <Route exact path='/category/Qualcomm Interview question 2' component={Qualc2}></Route>
            <Route exact path='/category/Qualcomm Interview question 3' component={Qualc3}></Route>
            <Route exact path='/category/Qualcomm Interview question 4' component={Qualc4}></Route>
            <Route exact path='/category/Qualcomm Interview question 5' component={Qualc5}></Route>
            <Route exact path='/category/Qualcomm Interview question 6' component={Qualc6}></Route>
            <Route exact path='/category/Qualcomm Interview question 7' component={Qualc7}></Route>
            <Route exact path='/category/Qualcomm Interview question 8' component={Qualc8}></Route>
            <Route exact path='/category/Qualcomm Interview question 9' component={Qualc9}></Route>

            <Route exact path='/category/Qualcomm Interview question 11' component={Qualc11}></Route>
            <Route exact path='/category/Qualcomm Interview question 12' component={Qualc12}></Route>
            <Route exact path='/category/Qualcomm Interview question 13' component={Qualc13}></Route>
            <Route exact path='/category/Qualcomm Interview question 14' component={Qualc14}></Route>
            <Route exact path='/category/Qualcomm Interview question 15' component={Qualc15}></Route>



            <Route exact path='/category/Snapdeal Interview question 1' component={Snpd1}></Route>
            <Route exact path='/category/Snapdeal Interview question 2' component={Snpd2}></Route>
            <Route exact path='/category/Snapdeal Interview question 3' component={Snpd3}></Route>
            <Route exact path='/category/Snapdeal Interview question 4' component={Snpd4}></Route>
            <Route exact path='/category/Snapdeal Interview question 5' component={Snpd5}></Route>
            <Route exact path='/category/Snapdeal Interview question 6' component={Snpd6}></Route>
            <Route exact path='/category/Snapdeal Interview question 7' component={Snpd7}></Route>
            <Route exact path='/category/Snapdeal Interview question 8' component={Snpd8}></Route>
            <Route exact path='/category/Snapdeal Interview question 9' component={Snpd9}></Route>
            <Route exact path='/category/Snapdeal Interview question 10' component={Snpd10}></Route>
            <Route exact path='/category/Snapdeal Interview question 11' component={Snpd11}></Route>
            <Route exact path='/category/Snapdeal Interview question 12' component={Snpd12}></Route>
            <Route exact path='/category/Snapdeal Interview question 13' component={Snpd13}></Route>


            <Route exact path='/category/Roadmaps for differnt carrers' component={RdMp}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Software Developer' component={SftDv}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Daatabase Administrator' component={DBa}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Computer hardware engineer' component={CHe}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Computer System Analyst' component={CSa}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Computer Network Architect' component={CNa}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Wev_dev' component={Wd}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Project Manager' component={Pm}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Computer Science Blogger' component={Blg}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Content Developer' component={Cd}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Author of Programming books' component={Auth}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Online Marketing' component={Onli}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Web Designer' component={WebD}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Startups' component={Strt}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Sales and Marketig' component={Sam}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/Professors of programming language' component={Pro}></Route>
            <Route exact path='/category/Roadmaps for differnt carrers/PCB Designer' component={Pcb}></Route>



            <Route exact path='/Blogs/Front-end' component={Fronte}></Route>
            <Route exact path='/Blogs/Back-end' component={Backe}></Route>
            <Route exact path='/Blogs/AI' component={AI}></Route>
            <Route exact path='/Blogs/Full Stack Developer' component={Fds}></Route>
            <Route exact path='/Blogs/Data Scientist' component={Dscien}></Route>
            <Route exact path='/Blogs/Data Analyst' component={DAnal}></Route>
            <Route exact path='/Blogs/Android Developer' component={Androi}></Route>
            <Route exact path='/Blogs/Blockchain' component={Block}></Route>
            <Route exact path='/Blogs/Computer Network Architect' component={Neto}></Route>
            <Route exact path='/Blogs/Database Administrator' component={Admins}></Route>




            {/* <Route exact path='/category/Data Structure' component={DataIndex}></Route>
            <Route exact path='/category/Data Strucutre/Array' component={ArrD}></Route>
            <Route exact path='/category/Array/intro' component={ArrayInt}></Route>
            <Route exact path='/category/Data Structure/Array/Introduction' component={ArrayIntD}></Route>
            <Route exact path='/category/Data Structure/Array/Introduction in C++' component={ArrayDC}></Route>
            <Route exact path='/category/Data Structure/Array/Introduction in Java' component={ArrayDJ}></Route>
            <Route exact path='/category/Data Structure/Array/Introduction in Python' component={ArrayDP}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation' component={ArrayRotInd}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Program for array rotation' component={ArrayRot1}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Reversal algorithm for array rotation' component={ArrayRot2}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Block swap algorithm for array rotation' component={ArrayRot3}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Program to cyclically rotate an array by one' component={ArrayRot4}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Search an element in a sorted and rotated array' component={ArrayRot5}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Given a sorted and rotated array, find if there is a pair with a given sum' component={ArrayRot6}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Find maximum value of Sum( i*arr[i]) with only rotations on given array allowed' component={ArrayRot7}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Maximum sum of i*arr[i] among all rotations of a given array' component={ArrayRot8}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Find the Rotation Count in Rotated Sorted array' component={ArrayRot9}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Quickly find multiple left rotations of an array' component={ArrayRot10}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Find the minimum element in a sorted and rotated array' component={ArrayRot11}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Reversal algorithm for right rotation of an array' component={ArrayRot12}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Find a rotation with maximum hamming distance' component={ArrayRot14}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Queries on Left and Right Circular shift on array' component={ArrayRot15}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Print left rotation of array in O(n) time and O(1) space' component={ArrayRot16}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Find element at given index after a number of rotations' component={ArrayRot17}></Route>
            <Route exact path='/category/Data Structure/Array/Array Rotation/Split the array and add the first part to the end' component={ArrayRot13}></Route>


            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement' component={RearrangInd}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Write a program to reverse an array or string' component={Rearrang1}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange positive and negative numbers in O(n) time and O(1) extra space' component={Rearrang2}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Move all zeroes to end of array' component={Rearrang3}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Minimum swaps required to bring all elements less than or equal to k together' component={Rearrang4}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange array such that even positioned are greater than odd' component={Rearrang5}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Double the first element and move zero to end' component={Rearrang6}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange positive and negative numbers with constant extra space' component={Rearrang7}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange an array such that ‘arr[j]’ becomes ‘i’ if ‘arr[i]’ is ‘j’' component={Rearrang8}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange an array in maximum minimum form' component={Rearrang9}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Move all negative elements to end in order with extra space allowed' component={Rearrang10}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Rearrange array such that even index elements are smaller and odd index elements are greater' component={Rearrang11}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Positive elements at even and negative at odd positions' component={Rearrang12}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Replace every array element by multiplication of previous and next' component={Rearrang13}></Route>
            <Route exact path='/category/Data Structure/Array/Arrangement Rerrangement/Shuffle a given array' component={Rearrang14}></Route>



            <Route exact path='/category/Data Structure/Array/Order Statistic' component={ArOS}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/K’th Smallest/Largest Element in Unsorted Array' component={ArOS1}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/k largest(or smallest) elements in an array | added Min Heap method' component={ArOS2}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Program to find largest element in an array' component={ArOS3}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Find the largest three elements in an array' component={ArOS4}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Program for Mean and median of an unsorted array' component={ArOS5}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Minimum product of k integers in an array of positive Integers' component={ArOS6}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/K maximum sum combinations from two arrays' component={ArOS7}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/k smallest elements in same order using O(1) extra space' component={ArOS8}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/k-th smallest absolute difference of two elements in an array' component={ArOS9}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Find the smallest and second smallest elements in an array' component={ArOS10}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Maximum sum such that no two elements are adjacent' component={ArOS11}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Maximum and minimum of an array using minimum number of comparisons' component={ArOS12}></Route>
            <Route exact path='/category/Data Structure/Array/Order Statistic/Median of Stream of Running Integers using STL' component={ArOS13}></Route>


            <Route exact path='/category/Data Structure/Array/Range queries' component={ArRq}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/MO’s Algorithm' component={ArRq1}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Range sum query using Sparse Table' component={ArRq2}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Range Queries for Frequencies of array elements' component={ArRq3}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Range LCM Queries' component={ArRq4}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Queries for GCD of all numbers of an array except elements in a given range' component={ArRq5}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Number of elements less than or equal to a given number in a given subarray (Including Updates)' component={ArRq6}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Queries for decimal values of subarrays of a binary array' component={ArRq7}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Number whose sum of XOR with given array range is maximum' component={ArRq8}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Array range queries over range queries' component={ArRq9}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Array range queries for elements with frequency same as value' component={ArRq10}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Number of indexes with equal elements in given range' component={ArRq11}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Total numbers with no repeated digits in a range' component={ArRq12}></Route>
            <Route exact path='/category/Data Structure/Array/Range queries/Difference Array | Range update query in O(1)' component={ArRq13}></Route>



            <Route exact path='/category/Data Structure/Array/Sorting and Searching' component={ArSS}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Alternative Sorting' component={ArSS1}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Sort an array according to absolute difference with given value' component={ArSS2}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Merge an array of size n into another array of size m+n' component={ArSS3}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Sort 1 to N by swapping adjacent elements' component={ArSS4}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Sort elements by frequency' component={ArSS5}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Two elements whose sum is closest to zero' component={ArSS6}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Minimum number of swaps required to sort an array' component={ArSS7}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Search, insert and delete in an unsorted array' component={ArSS8}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Searching in an array where adjacent differ by at most k' component={ArSS9}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Find the element that appears once' component={ArSS10}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Leaders in an array' component={ArSS11}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Check if an array has a majority element' component={ArSS12}></Route>
            <Route exact path='/category/Data Structure/Array/Sorting and Searching/Find a Fixed Point in a given array' component={ArSS13}></Route>


            <Route exact path='/category/Data Structure/Array/Optimization Problem' component={ArOp}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Largest Sum Contiguous Subarray' component={ArOp1}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Find the subarray with least average' component={ArOp2}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization ProblemMinimize the maximum difference between the heights/' component={ArOp3}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Maximum Sum Increasing Subsequence' component={ArOp4}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Find maximum average subarray of k length' component={ArOp5}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Number of subsets with product less than k' component={ArOp6}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Find the smallest positive integer value that cannot be represented as sum of any subset of a given array' component={ArOp7}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Size of The Subarray With Maximum Sum' component={ArOp8}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Find minimum difference between any two elements' component={ArOp9}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Space optimization using bit manipulations' component={ArOp10}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Longest Span with same Sum in two Binary arrays' component={ArOp11}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Maximum profit by buying and selling a share at most twice' component={ArOp12}></Route>
            <Route exact path='/category/Data Structure/Array/Optimization Problem/Find the minimum distance between two numbers' component={ArOp13}></Route>


            <Route exact path='/category/Data Structure/Array/Matrix' component={ArrMat}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Rotate Matrix Elements' component={ArMat1}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Rotate a matrix by 90 degree without using any extra space' component={ArMat2}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Turn an image by 90 degree' component={ArMat3}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Check if all rows of a matrix are circular rotations of each other' component={ArMat4}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Find the row with maximum number of 1s' component={ArMat5}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Matrix Multiplication | Recursive' component={ArMat6}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Program for scalar multiplication of a matrix' component={ArMat7}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Find distinct elements common to all rows of a matrix' component={ArMat8}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Find maximum element of each row in a matrix' component={ArMat9}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Shift matrix elements row-wise by k' component={ArMat10}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Print a given matrix in counter-clock wise spiral form' component={ArMat11}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Maximum path sum in matrix' component={ArMat12}></Route>
            <Route exact path='/category/Data Structure/Array/Matrix/Move matrix elements in given direction and add elements with same value' component={ArMat13}></Route>


            <Route exact path='/category/Data Structure/Array/Binary Tree' component={BInd}></Route>
            <Route exact path='/category/Data Structure/Matrix/Construction and Destruction' component={BtcInd}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Tree from given Inorder and Preorder traversals' component={BtC1}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct a tree from Inorder and Level order traversals' component={BtC2}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Complete Binary Tree from its Linked List Representation' component={BtC3}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct a complete binary tree from given array in level order fashion' component={BtC4}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Full Binary Tree from given preorder and postorder traversals' component={BtC5}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Full Binary Tree using its Preorder traversal and Preorder traversal of its mirror tree' component={BtC6}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct a special tree from given preorder traversal' component={BtC7}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct tree from ancestor matrix' component={BtC8}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Ancestor Matrix from a Given Binary Tree' component={BtC9}></Route>
            <Route exact path='/category/Data Structure/Array/Binary Tree/Construction and Conversion/Construct Special Binary Tree from given Inorder traversal' component={BtC10}></Route> */}





            <Route path='/login'>
              <Heading />
              <About />
            </Route>
            <Route path='/about'>
              <Heading />
              <About />
            </Route>
            <Route exact path="/">
              <Heading />
              <Home />

            </Route>
          </Switch>
        </Router>
      </div>

    </>
  );
}

export default App;
